<template>
    <b-overlay :show="busy" rounded="sm">
        <b-card class="standardpage reports invoices border-none">
            <div class="availtable datatable">
                <b-card class="w-100pct">

                    <b-card-body class="py-0 px-0">
                        <!-- {{ parent }} -->

                        <b-tabs class="gridtabs">

                            <b-tab active>
                                <template #title>
                                    <i :class="options.icon_header" class="text-primary mr-1"></i>
                                    {{ item.docno ? item.docno : item.locator }}
                                    <span class="text-warning">&lt;{{ selection.length == 0 ? "new" : "edit"
                                        }}&gt;</span>
                                </template>
                                <p class="py-3 px-0">
                                    <b-row>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-row>
                                                <b-col>
                                                    <b-form-group label-cols="12" label="Type" label-size="sm">
                                                        <treeselect placeholder="Type" v-model="item.type"
                                                            :clearable="false" :multiple="false" :options="options_type"
                                                            :matchKeys="['id']"
                                                            :disabled="parent == 'CAR' || parent == 'HTL'">
                                                            <div slot="value-label" slot-scope="{ node }">
                                                                {{ node.raw.id }}
                                                            </div>
                                                        </treeselect>
                                                    </b-form-group>

                                                </b-col>
                                                <b-col>
                                                    <b-form-group label-cols="12" label="Source" label-size="sm">
                                                        <b-input-group>
                                                            <b-form-input v-model="item.source"
                                                                :debounce="options.debounce" placeholder="Source"
                                                                :disabled="true"></b-form-input>
                                                        </b-input-group>
                                                    </b-form-group>

                                                </b-col>
                                            </b-row>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-row>
                                                <b-col>
                                                    <b-form-group label-cols="12" label="Status" label-size="sm">
                                                        <treeselect placeholder="Status" v-model="item.status"
                                                            :clearable="false" :multiple="false"
                                                            :options="options_status" :matchKeys="['id']"
                                                            :disabled="readonly">
                                                            <div slot="value-label" slot-scope="{ node }">
                                                                {{ node.raw.id }} | {{ node.raw.label }}
                                                            </div>
                                                        </treeselect>

                                                    </b-form-group>
                                                </b-col>
                                                <b-col> <b-form-group label="State" label-for="state" label-cols="12">
                                                        <treeselect v-model="item.state" :options="options_state"
                                                            :clearable="false" placeholder="Select..."
                                                            :disabled="item.source == 'GDS'"></treeselect>
                                                    </b-form-group></b-col>
                                            </b-row>
                                        </b-col>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-row>
                                                <b-col>
                                                    <b-form-group label-cols="12" label="Days" label-size="sm">
                                                        <b-input-group>
                                                            <b-form-input v-model="item.days"
                                                                :debounce="options.debounce" placeholder="Days"
                                                                :disabled="true"></b-form-input>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </b-col>
                                                <!-- 
                                                <b-col> <b-form-group label-cols="12" label="Qty" label-size="sm">
                                                <b-input-group>
                                                    <b-form-input v-model="item.qty" :debounce="options.debounce"
                                                        placeholder="Qty" :disabled="readonly"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary" :disabled="readonly"
                                                            @click="item.qty = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group></b-col> -->

                                            </b-row>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-row>
                                                <b-col>
                                                    <b-form-group :disabled="readonly" label-cols="12" label="Agent"
                                                        label-size="sm">
                                                        <b-input-group>
                                                            <b-form-input v-model="item.agent"
                                                                placeholder="Agent"></b-form-input>
                                                            <b-input-group-append>
                                                                <b-button size="sm" variant="outline-secondary"
                                                                    :disabled="readonly" @click="item.agent = ''">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col>
                                                    <b-form-group label-cols="12" label="Invoice No" label-size="sm">
                                                        <b-input-group>
                                                            <b-form-input v-model="item.invoiceno"
                                                                :debounce="options.debounce" placeholder="Invoice No"
                                                                :disabled="!user.permissions.includes('bookings.admin')"></b-form-input>
                                                            <b-input-group-append>
                                                                <b-button size="sm" variant="outline-secondary"
                                                                    :disabled="!user.permissions.includes('bookings.admin')"
                                                                    @click="item.invoiceno = ''">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>

                                        </b-col>


                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-row>
                                                <b-col>
                                                    <b-form-group label-cols="12" label="Payment Method"
                                                        label-size="sm">
                                                        <b-input-group>
                                                            <treeselect placeholder="Payment Method"
                                                                v-model="item.payby" :clearable="false"
                                                                :multiple="false" :options="payby_options"
                                                                :matchKeys="['id']">
                                                                <div slot="value-label" slot-scope="{ node }">
                                                                    {{ node.raw.id }}
                                                                </div>
                                                            </treeselect>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col>
                                                    <b-form-group label-cols="12" label="Date Issued" label-size="sm"
                                                        :disabled="true">
                                                        <b-input-group>
                                                            <b-form-input :value="item.issued_at
                                                                ? this.$helpers.datetimefield(item.issued_at)
                                                                : null
                                                                " :disabled="readonly"></b-form-input>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-row>
                                                <b-col>
                                                    <b-form-group label-cols="12" label="Itinerary Layout"
                                                        label-size="sm">
                                                        <b-input-group>
                                                            <treeselect placeholder="Layout"
                                                                v-model="item.proforma_layout" :clearable="false"
                                                                :multiple="false" :options="options_proformalayout"
                                                                :matchKeys="['id']">
                                                                <div slot="value-label" slot-scope="{ node }">
                                                                    {{ node.raw.label }}
                                                                </div>
                                                            </treeselect>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col>
                                                    <b-form-group label-cols="12" label="Segments Priced?"
                                                        label-size="sm">
                                                        <b-input-group>
                                                            <treeselect placeholder="Segments Priced"
                                                                v-model="item.segments_priced" :clearable="false"
                                                                :multiple="false" :options="options_segmentspriced"
                                                                :matchKeys="['id']">
                                                                <div slot="value-label" slot-scope="{ node }">
                                                                    {{ node.raw.label }}
                                                                </div>
                                                            </treeselect>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>

                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-row>
                                                <b-col>
                                                    <b-form-group label-cols="12" label="Quoted" label-size="sm">
                                                        <b-input-group>
                                                            <b-form-input v-model="item.quoted"
                                                                :debounce="options.debounce" placeholder="Quoted"
                                                                :disabled="readonly"></b-form-input>
                                                            <b-input-group-append>
                                                                <b-button size="sm" variant="outline-secondary"
                                                                    :disabled="readonly" @click="item.quoted = ''">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col><b-form-group label-cols="12" label="Currency" label-size="sm">
                                                        <b-input-group>
                                                            <b-form-input v-model="item.currency"
                                                                :debounce="options.debounce" placeholder="Currency"
                                                                :disabled="readonly"></b-form-input>
                                                            <b-input-group-append>
                                                                <b-button size="sm" variant="outline-secondary"
                                                                    :disabled="readonly" @click="item.currency = ''">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </b-form-group></b-col>

                                            </b-row>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-row>
                                                <b-col>
                                                    <b-form-group label-cols="12" label="Locator" label-size="sm">
                                                        <b-input-group>
                                                            <b-form-input v-model="item.locator"
                                                                :debounce="options.debounce" placeholder="Locator"
                                                                :disabled="true"></b-form-input>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </b-col>

                                                <b-col>
                                                    <b-form-group label-cols="12" label="DocumentNo" label-size="sm">
                                                        <b-input-group>
                                                            <b-form-input v-model="item.docno"
                                                                :debounce="options.debounce" placeholder="DocumentNo"
                                                                :disabled="true"></b-form-input>
                                                            <!-- <b-input-group-append>
                                                                <b-button size="sm" variant="outline-secondary"
                                                                    :disabled="true" @click="item.docno = ''">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-append> -->
                                                        </b-input-group>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12" label="Supplier BL A/C" label-size="sm">
                                                <treeselect placeholder="Select blac..."
                                                    searchPromptText="Type at least 3 chars..." v-model="item.blac"
                                                    :clearable="true" :async="true" :load-options="treeselect_loadBLAC"
                                                    :show-count="true" :flatten-search-results="true"
                                                    :disable-branch-nodes="true" :matchKeys="['id']" search-nested
                                                    :disabled="!user.permissions.includes('bookings.save')">
                                                    <div slot="value-label" slot-scope="{ node }">
                                                        {{ node.raw.id }}
                                                    </div>
                                                </treeselect>
                                            </b-form-group>
                                        </b-col>


                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="BL Invoice No" label-for="blinvoiceno" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="item.blinvoiceno"
                                                        placeholder="BL Invoice No" size="sm"
                                                        :disabled="!user.permissions.includes('bookings.save')"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm"
                                                            :disabled="!user.permissions.includes('bookings.save')"
                                                            variant="outline-secondary" @click="item.blinvoiceno = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group id="bltotal" label="BL Total GBP" label-for="bltotal"
                                                label-cols="12">
                                                <b-input-group class="treeselect_all" style="left:75px; top:-12px">
                                                    <i class="fa fa-info-circle text-danger"></i>
                                                </b-input-group>
                                                <b-tooltip target="bltotal" triggers="hover" placement="bottom">Be sure
                                                    to
                                                    check your Bought Ledger costs!</b-tooltip>
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="item.bltotal"
                                                        placeholder="BL Total" size="sm" :state="false"
                                                        :disabled="!user.permissions.includes('bookings.save')"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm"
                                                            :disabled="!user.permissions.includes('bookings.save')"
                                                            variant="outline-secondary" @click="item.bltotal = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="SL Total GBP" label-for="sltotal" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="item.sltotal"
                                                        placeholder="SL Total" size="sm"
                                                        :disabled="!user.permissions.includes('bookings.save')"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm"
                                                            :disabled="!user.permissions.includes('bookings.save')"
                                                            variant="outline-secondary" @click="item.sltotal = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12" label="Client SL A/C" label-size="sm">
                                                <treeselect placeholder="Select slac..."
                                                    searchPromptText="Type at least 3 chars..." v-model="item.slac"
                                                    :clearable="true" :async="true" :load-options="treeselect_loadSLAC"
                                                    :show-count="true" :flatten-search-results="true"
                                                    :disable-branch-nodes="true" :matchKeys="['id']" search-nested
                                                    :disabled="!user.permissions.includes('bookings.save')">
                                                    <div slot="value-label" slot-scope="{ node }">
                                                        {{ node.raw.id }}
                                                    </div>
                                                </treeselect>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12" label="Your Ref/PO" label-size="sm">
                                                <b-input-group>
                                                    <b-form-input v-model="item.yourref" :debounce="options.debounce"
                                                        placeholder="Your Ref/PO"
                                                        :disabled="!user.permissions.includes('bookings.save')"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            :disabled="!user.permissions.includes('bookings.save')"
                                                            @click="item.yourref = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12" label="Event" label-size="sm">
                                                <treeselect placeholder="Select event..." v-model="item.eventcode"
                                                    :clearable="true" :async="true" :load-options="treeselect_loadEvent"
                                                    searchPromptText="Type at least 4 chars..." :show-count="true"
                                                    :flatten-search-results="true" :disable-branch-nodes="true"
                                                    :matchKeys="['id']" search-nested
                                                    :disabled="!user.permissions.includes('bookings.save')">
                                                    <div slot="value-label" slot-scope="{ node }">
                                                        {{ node.raw.id }}
                                                    </div>
                                                </treeselect>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">

                                            <b-form-group label-cols="12" label="Booker" label-size="sm">
                                                <b-input-group>
                                                    <b-form-input v-model="item.booker" :debounce="options.debounce"
                                                        placeholder="Booker" :disabled="readonly"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            :disabled="readonly"
                                                            @click="item.booker = reversenamecap(item.booker)"
                                                            title="Reverse Name Capitalise">
                                                            <i class="fa fa-exchange text-primary"></i>
                                                        </b-button>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            :disabled="readonly" @click="item.booker = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                    </b-row>

                                    <b-row align-v="end" class="nopadding my-1 background-transparent" no-gutters>
                                        <b-col cols="11" class="text-left text-orange mt-n2 divider ">
                                            <b-row>
                                                <b-col class="text-left">First Segment</b-col>
                                                <b-col class="text-right">1 of Total</b-col>
                                            </b-row>

                                        </b-col>
                                        <b-col class="text-right pl-1 mb-n1" cols="1">
                                            <b-form-group class="text-orange" label="" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="number" class="xs" :min="0" :max="50"
                                                        v-model="item.qty" :debounce="options.debounce"
                                                        placeholder="Segment"
                                                        :disabled="segments.items.length > 1"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button class="xs" size="sm" variant="outline-secondary"
                                                            :disabled="segments.items.length > 1"
                                                            @click="item.qty = '0'">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>


                                    <b-row>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group :disabled="segments.items.length > 0" label-cols="12"
                                                label="Start City" label-size="sm">
                                                <treeselect placeholder="Select city..."
                                                    searchPromptText="Type at least 3 chars..." v-model="item.startcity"
                                                    :disabled="segments.items.length > 0"
                                                    :clearable="this.segments.items.length > 0" :async="true"
                                                    :load-options="treeselect_loadAirport" :show-count="true"
                                                    :flatten-search-results="true" :disable-branch-nodes="true"
                                                    :matchKeys="['id']" :title="item.startcity +
                                                        ' ( ' +
                                                        item.startcityname +
                                                        ' )'
                                                        " search-nested>
                                                    <div slot="value-label" slot-scope="{ node }">
                                                        {{ node.raw.id }}
                                                        {{ node.raw.id && item.startcityname ? '( ' + item.startcityname
                                                            +
                                                            ')' : "" }}
                                                    </div>
                                                </treeselect>
                                            </b-form-group>

                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group :disabled="segments.items.length > 0" label-cols="12"
                                                label="Start DateTime" label-size="sm">
                                                <b-input-group>
                                                    <daterangepicker style="width:auto !important" size="sm" ref="date"
                                                        v-model="datestart" :disabled="segments.items.length > 0"
                                                        :opens="'right'" :single-date-picker="'single'" :locale-data="{
                                                            direction: 'ltr',
                                                            format: 'dd/mm/yy HH:MM',
                                                            daysOfWeek: [
                                                                'Sun',
                                                                'Mon',
                                                                'Tue',
                                                                'Wed',
                                                                'Thu',
                                                                'Fri',
                                                                'Sat',
                                                            ],
                                                            monthNames: [
                                                                'January',
                                                                'February',
                                                                'March',
                                                                'April',
                                                                'May',
                                                                'June',
                                                                'July',
                                                                'August',
                                                                'September',
                                                                'October',
                                                                'November',
                                                                'December',
                                                            ],
                                                            firstDay: 1,
                                                        }" :ranges="false" :showDropdowns="true" :linkedCalendars="true" :timePicker="true"
                                                        :timePicker24Hour="true" :time-picker-increment="1">
                                                    </daterangepicker>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            :disabled="segments.items.length > 0"
                                                            @click="item.start_at = null">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group :disabled="segments.items.length > 0" label-cols="12"
                                                label="End DateTime" label-size="sm">
                                                <b-input-group>
                                                    <daterangepicker style="width:auto !important" size="sm" ref="date"
                                                        v-model="dateend" :disabled="segments.items.length > 0"
                                                        :opens="'right'" :single-date-picker="'single'" :locale-data="{
                                                            direction: 'ltr',
                                                            format: 'dd/mm/yy HH:MM',
                                                            daysOfWeek: [
                                                                'Sun',
                                                                'Mon',
                                                                'Tue',
                                                                'Wed',
                                                                'Thu',
                                                                'Fri',
                                                                'Sat',
                                                            ],
                                                            monthNames: [
                                                                'January',
                                                                'February',
                                                                'March',
                                                                'April',
                                                                'May',
                                                                'June',
                                                                'July',
                                                                'August',
                                                                'September',
                                                                'October',
                                                                'November',
                                                                'December',
                                                            ],
                                                            firstDay: 1,
                                                        }" :ranges="false" :showDropdowns="true" :linkedCalendars="true" :timePicker="true"
                                                        :timePicker24Hour="true" :time-picker-increment="1">
                                                    </daterangepicker>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            :disabled="segments.items.length > 0"
                                                            @click="item.end_at = null">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group :disabled="segments.items.length > 0" label-cols="12"
                                                label="End City" label-size="sm">
                                                <treeselect placeholder="Select city..."
                                                    searchPromptText="Type at least 3 chars..." v-model="item.endcity"
                                                    :disabled="segments.items.length > 0"
                                                    :clearable="this.segments.items.length > 0" :async="true"
                                                    :load-options="treeselect_loadAirport" :show-count="true"
                                                    :flatten-search-results="true" :disable-branch-nodes="true"
                                                    :matchKeys="['id']" :title="item.endcity +
                                                        ' ( ' +
                                                        item.endcityname +
                                                        ' )'
                                                        " search-nested>
                                                    <div slot="value-label" slot-scope="{ node }">
                                                        {{ node.raw.id }}
                                                        {{ node.raw.id && item.endcityname ? '( ' + item.endcityname + ' ) '
                                                        : "" }}
                                                    </div>
                                                </treeselect>

                                            </b-form-group>

                                        </b-col>

                                        <b-col cols="12" sm="6" md="6" xl="6">
                                            <b-form-group :disabled="segments.items.length > 0" label-cols="12"
                                                label="Start Location" label-size="sm">
                                                <b-input-group>
                                                    <b-form-input v-model="item.startlocation"
                                                        :debounce="options.debounce" placeholder="Start Location"
                                                        :disabled="readonly"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            :disabled="readonly" @click="item.startlocation = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" sm="6" md="6" xl="6">
                                            <b-form-group :disabled="segments.items.length > 0" label-cols="12"
                                                label="End Location" label-size="sm">
                                                <b-input-group>
                                                    <b-form-input v-model="item.endlocation"
                                                        :debounce="options.debounce" placeholder="End Location"
                                                        :disabled="readonly"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            :disabled="readonly" @click="item.endlocation = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group :disabled="segments.items.length > 0" id="cabinco2"
                                                label-cols="12" label="Cabin CO2" label-size="sm">
                                                <b-input-group class="treeselect_all" style="left:65px; top:-15px">
                                                    <i class="fa fa-leaf text-primary"></i>
                                                </b-input-group>
                                                <b-tooltip target="cabinco2" triggers="hover"
                                                    placement="bottom">Required
                                                    field for
                                                    Carbon</b-tooltip>
                                                <treeselect placeholder="Cabin CO2" v-model="item.cabin"
                                                    :clearable="false" :multiple="false" :options="options_cabin"
                                                    :matchKeys="['id']" :disabled="segments.items.length > 0">
                                                    <div slot="value-label" slot-scope="{ node }">
                                                        {{ node.raw.id }}
                                                    </div>
                                                </treeselect>
                                            </b-form-group>

                                        </b-col>

                                        <b-col id="equipmentco2" cols="12" sm="6" md="4" xl="3">
                                            <b-form-group :disabled="segments.items.length > 0"
                                                v-if="item.type == 'CAR'" label-cols="12" label="Equipment (SIPP) CO2"
                                                label-size="sm">
                                                <b-input-group class="treeselect_all" style="left:120px; top:-15px">
                                                    <i class="fa fa-leaf text-primary"></i>
                                                </b-input-group>
                                                <treeselect :disabled="segments.items.length > 0"
                                                    placeholder="Equipment (SIPP)" v-model="item.equipment"
                                                    :clearable="false" :multiple="false" :options="options_cartypecode"
                                                    :matchKeys="['id']">
                                                    <div slot="value-label" slot-scope="{ node }">
                                                        {{ node.raw.id }}
                                                    </div>
                                                </treeselect>
                                            </b-form-group>
                                            <b-form-group :disabled="segments.items.length > 0"
                                                v-if="item.type == 'AIR'" label-cols="12"
                                                label="Equipment (aircraft) CO2" label-size="sm">
                                                <b-input-group class="treeselect_all" style="left:140px; top:-15px">
                                                    <i class="fa fa-leaf text-primary"></i>
                                                </b-input-group>
                                                <!-- <treeselect :disabled="segments.items.length > 0"
                                                    placeholder="Equipment (aircraft)" v-model="item.equipment"
                                                    :clearable="false" :options="options_aircraft">
                                                    <div slot="value-label" slot-scope="{ node }">
                                                        {{ node.raw.id }}
                                                    </div>
                                                </treeselect> -->
                                                <treeselect :disabled="segments.items.length > 0"
                                                    placeholder="Select aircraft..." v-model="item.equipment"
                                                    searchPromptText="Type at least 3 chars..." :clearable="true"
                                                    :async="true" :load-options="treeselect_loadAircraft"
                                                    :show-count="true" :flatten-search-results="true"
                                                    :disable-branch-nodes="true" :matchKeys="['id']" search-nested>
                                                    <div slot="value-label" slot-scope="{ node }">
                                                        {{ node.raw.id }}
                                                    </div>
                                                </treeselect>

                                                <!-- <treeselect placeholder="Equipment (SIPP)" v-model="item.equipment"
                                                    :clearable="false" :multiple="false" :options="options_cartypecode"
                                                    :matchKeys="['id']">
                                                    <div slot="value-label" slot-scope="{ node }">
                                                        {{ node.raw.id }}
                                                    </div>
                                                </treeselect> -->
                                            </b-form-group>
                                            <b-form-group :disabled="segments.items.length > 0"
                                                v-if="item.type !== 'AIR' && item.type !== 'CAR'" label-cols="12"
                                                label="Equipment CO2" label-size="sm">
                                                <b-input-group class="treeselect_all" style="left:90px; top:-15px">
                                                    <i class="fa fa-leaf text-primary"></i>
                                                </b-input-group>
                                                <b-input-group>
                                                    <b-form-input :disabled="segments.items.length > 0"
                                                        v-model="item.equipment" :debounce="options.debounce"
                                                        placeholder="Equipment"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            :disabled="segments.items.length > 0"
                                                            @click="item.equipment = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                            <b-tooltip target="equipmentco2" triggers="hover"
                                                placement="bottom">Required
                                                field for
                                                Carbon</b-tooltip>
                                        </b-col>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12" label="ConfirmNo" label-size="sm">
                                                <b-input-group>
                                                    <b-form-input v-model="item.confirmno" :debounce="options.debounce"
                                                        placeholder="ConfirmNo" :disabled="readonly"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            :disabled="readonly" @click="item.confirmno = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>



                                    </b-row>

                                    <b-row align-v="end" class="nopadding my-1 background-transparent" no-gutters>
                                        <b-col cols="11" class="text-left text-orange mt-n2 divider ">
                                            <b-row>
                                                <b-col class="text-left">First Traveller</b-col>
                                                <b-col class="text-right">1 of Total</b-col>
                                            </b-row>

                                        </b-col>
                                        <b-col class="text-right pl-1 mb-n1" cols="1">
                                            <b-form-group class="text-orange" label="" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="number" class="xs" :min="0" :max="50"
                                                        v-model="item.pax" :debounce="options.debounce"
                                                        placeholder="Pax"
                                                        :disabled="!(item.passenger == 'ALL' || item.passenger == 'VIP')"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button class="xs" size="sm" variant="outline-secondary"
                                                            :disabled="!(item.passenger == 'ALL' || item.passenger == 'VIP')"
                                                            @click="item.pax = '0'">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group :disabled="travellers.items.length != 1" label-cols="12"
                                                label="Passenger" label-size="sm">
                                                <b-input-group>
                                                    <b-form-input v-model="item.passenger" :debounce="options.debounce"
                                                        placeholder="Passenger" :disabled="readonly"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            :disabled="readonly"
                                                            @click="item.passenger = reversenamecap(item.passenger, true)"
                                                            title="Reverse Name Capitalise">
                                                            <i class="fa fa-exchange text-primary"></i>
                                                        </b-button>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            :disabled="readonly" @click="item.passenger = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group :disabled="travellers.items.length != 1" label-cols="12"
                                                label="Surname" label-size="sm">
                                                <b-input-group>
                                                    <b-form-input v-model="item.surname" :debounce="options.debounce"
                                                        placeholder="Surname" :disabled="readonly"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            :disabled="readonly" @click="item.surname = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group :disabled="travellers.items.length != 1" label-cols="12"
                                                label="First Name" label-size="sm">
                                                <b-input-group>
                                                    <b-form-input v-model="item.firstname" :debounce="options.debounce"
                                                        placeholder="First Name" :disabled="readonly"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            :disabled="readonly" @click="item.firstname = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>


                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-row>
                                                <b-col>
                                                    <b-form-group :disabled="travellers.items.length != 1"
                                                        label-cols="12" label="Title" label-size="sm">
                                                        <b-input-group>
                                                            <b-form-input v-model="item.title"
                                                                :debounce="options.debounce" placeholder="Title"
                                                                :disabled="readonly" list="list-title"></b-form-input>
                                                            <b-input-group-append>
                                                                <b-button size="sm" variant="outline-secondary"
                                                                    :disabled="readonly" @click="item.title = ''">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </b-col>
                                                <!-- <b-col>
                                                    <b-form-group label-cols="12" label="Travellers" label-size="sm">
                                                        <b-input-group>
                                                            <b-form-input type="number" :min="0" :max="50"
                                                                v-model="item.pax" :debounce="options.debounce"
                                                                placeholder="Pax" :disabled="readonly"></b-form-input>
                                                            <b-input-group-append>
                                                                <b-button size="sm" variant="outline-secondary"
                                                                    :disabled="readonly" @click="item.pax = '0'">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </b-col> -->
                                            </b-row>
                                        </b-col>
                                    </b-row>
                                </p>
                            </b-tab>

                            <b-tab>
                                <template #title>
                                    <i class="fa fa-commenting-o text-primary mr-1"></i>
                                    Details</template>
                                <p class="py-3 px-0">
                                    <b-row>
                                        <b-col cols="9">
                                            <b-form-group label="Subject" label-for="Subject" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="item.subject"
                                                        placeholder="Subject" size="sm"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" :disabled="true" variant="outline-secondary"
                                                            @click="item.subject = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group :disabled="readonly" label-cols="12" label="Agent"
                                                label-size="sm">
                                                <b-input-group>
                                                    <b-form-input v-model="item.agent" placeholder="Agent"
                                                        :disabled="true"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary" :disabled="true"
                                                            @click="item.agent = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="12">
                                            <b-form-group label="Details" label-for="details" label-cols="12">
                                                <b-form-textarea id="details" v-model="item.details"
                                                    placeholder="Details" rows="12"
                                                    class="smalltextarea"></b-form-textarea>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col v-if="item.type == 'CAR'" cols="12" sm="12" md="12" xl="12">
                                            <b-form-group label-cols="12" label="Voucher Info" label-size="sm">
                                                <b-input-group>
                                                    <b-form-input v-model="item.voucherinfo"
                                                        :debounce="options.debounce" placeholder="Voucher Info"
                                                        :disabled="false"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            :disabled="false" @click="item.voucherinfo = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                    <b-row v-if="item.type == 'AIR' || item.type == 'BAG' || item.type == 'LOW'"
                                        class="mt-1">
                                        <b-col cols="12" sm="12">
                                            <b-form-group label-cols="12" :label="loadlabel" label-size="sm"
                                                class="mb-0">
                                                <b-input-group>
                                                    <b-form-tags input-id="associatedno" v-model="item.associatedno"
                                                        tag-variant="primary" separator=" ,;/" placeholder="" size="sm"
                                                        class="h-29" add-button-text="+" add-on-change remove-on-delete
                                                        add-button-variant="outline-primary"></b-form-tags>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            @click="item.associatedno = null">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                        <b-button size="sm" variant="outline-primary"
                                                            @click="load_data('associatedno')">
                                                            <i
                                                                :class="load_busy ? 'fa fa-spinner fa-spin' : 'fa fa-upload'"></i>
                                                            Load To Booking
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                        <!-- <b-col cols="6" sm="6" v-if="item.type != 'AIR'">
                                            <b-form-group label-cols="12" label="GDS ConfirmNo" label-size="sm"
                                                class="mb-0">
                                                <b-input-group>
                                                    <b-form-input v-model="item.confirmno" placeholder="Confirmno"
                                                        :disabled="false"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary" :disabled="false"
                                                            @click="item.confirmno = item.confirmno">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                        <b-button size="sm" variant="outline-primary"
                                                            @click="item.confirmno = null">
                                                            <i class="fa fa-search"></i>
                                                            Find
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col> -->
                                    </b-row>
                                    <b-row class="mt-1">
                                        <b-col cols="6" sm="6" md="6" xl="6">
                                            <b-form-group label="Click x to remove or browse for document upload..."
                                                label-size="sm">
                                                <b-input-group>
                                                    <!-- :disabled="item.data ? false : true" -->
                                                    <b-input-group-prepend>
                                                        <b-button size="sm" title="delete" variant="outline-danger"
                                                            @click="fileUpload_clear">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-prepend>
                                                    <b-form-file class="ml-1 z-0" id="file-small" size="sm"
                                                        ref="file-input" :multiple="false" no-drop
                                                        @change="fileUpload_selected" :placeholder="fileUpload ? fileUpload.name : 'No file chosen'
                                                            " :disabled="fileUpload ? true : false"></b-form-file>
                                                    <b-input-group-append>
                                                        <b-button class="ml-1" size="sm" title="view file"
                                                            variant="outline-primary" @click="fileUpload_view"
                                                            :disabled="!fileUpload">
                                                            <i class="fa fa-download"></i>
                                                        </b-button>
                                                        <b-button class="ml-1" squared size="sm"
                                                            variant="outline-primary" @click="download()">
                                                            <i class="fa fa-download"></i>
                                                            Template
                                                        </b-button>
                                                    </b-input-group-append>

                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                    <b-row>

                                    </b-row>
                                </p>
                            </b-tab>

                            <!-- <b-tab>
                                <template #title>
                                    <i class="fa fa-gbp text-primary mr-1"></i> Accounting
                                </template>
                                <p class="py-3 px-0">
                                    <b-row>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="BL Invoice Date" label-for="blinvoicedate" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="item.blinvoicedate"
                                                        placeholder="BL Invoice Date" size="sm"
                                                        :disabled="readonly"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" :disabled="readonly" variant="outline-secondary"
                                                            @click="item.blinvoicedate = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="BL Cost Total" label-for="bltotal" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="item.bltotal"
                                                        placeholder="BL Cost Total" size="sm"
                                                        :disabled="!user.permissions.includes('bookings.save')"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm"
                                                            :disabled="!user.permissions.includes('bookings.save')"
                                                            variant="outline-secondary" @click="item.bltotal = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>



                                    </b-row>
                                    <b-row>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Amount GBP" label-for="amount" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="item.amount" placeholder="Amount GBP"
                                                        size="sm"
                                                        :disabled="!user.permissions.includes('bookings.save')"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm"
                                                            :disabled="!user.permissions.includes('bookings.save')"
                                                            variant="outline-secondary" @click="item.amount = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Tax" label-for="tax" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="item.tax" placeholder="Tax" size="sm"
                                                        :disabled="readonly"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" :disabled="readonly" variant="outline-secondary"
                                                            @click="item.tax = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>


                                    </b-row>

                                </p>
                            </b-tab> -->

                            <b-tab>
                                <template #title>
                                    <div class="badgecontainer pr-2 mr-1">
                                        <i class="fa fa-user text-primary mr-1"></i>
                                        Travellers
                                        <b-badge id="badge-travellers" variant="primary" class="edit_tab">
                                            {{ travellers_count }}</b-badge>
                                    </div>


                                </template>

                                <div v-if="travellers.pastespecial">
                                    <b-row class="mt-2">
                                        <b-col cols="9">
                                            <b-form-group>
                                                <b-form-checkbox-group id="travellers_paste_selected"
                                                    v-model="travellers.paste_selected"
                                                    :options="travellers.paste_options" value-field="id"
                                                    text-field="label"></b-form-checkbox-group>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="auto" class="text-right ml-auto">
                                            <b-row>
                                                <b-col cols="auto">
                                                    <b-link size="sm" variant="outline-primary"
                                                        @click="travellers_tab()">
                                                        {tab}
                                                    </b-link>
                                                </b-col>
                                                <b-col cols="auto">
                                                    <b-link size="sm" variant="outline-primary"
                                                        @click="travellers_headers()">
                                                        Headers
                                                    </b-link>
                                                </b-col>
                                                <!-- <b-col>
                                                    <b-link size="sm" variant="outline-primary"
                                                        @click="travellers_formatter()">
                                                        Formatter
                                                    </b-link>
                                                </b-col> -->
                                                <b-col>
                                                    <b-link size="sm" variant="outline-primary"
                                                        @click="travellers_paste_read()">
                                                        <i class="fa fa-magic"></i>
                                                        Read It
                                                    </b-link>
                                                </b-col>
                                            </b-row>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="12">
                                            <b-form-group label-cols="12">
                                                <b-form-textarea id="data" v-model="travellers.paste"
                                                    placeholder="Paste traveller data" rows="6"
                                                    class="smalltextarea courier"></b-form-textarea>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                </div>

                                <b-row>
                                    <b-col>
                                        <d-table classdivtable="availtable datatable nested" refid="travellers"
                                            :icon="travellers.icon" :busy="travellers.busy" :tools="travellers.tools"
                                            :badges="travellers.badges" :toolbarlibrary="travellers.toolbarlibrary"
                                            :fields="travellers.fields" :items="travellers.items"
                                            :page="travellers.page" :showpages="false" @load="travellers_load"
                                            @click="travellers_click" @select="travellers_select" :tableheight="230">
                                        </d-table>
                                    </b-col>
                                </b-row>
                                <b-row v-if="travellers.edit" class="mt-3">
                                    <b-col cols="12" sm="6" md="3" xl="3">
                                        <b-form-group label="Passenger" label-for="Passenger" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="travellers.item.passenger"
                                                    placeholder="Passenger" size="sm" :disabled="true"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" :disabled="true" variant="outline-secondary"
                                                        @click="travellers.item.passenger = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="3" xl="3">
                                        <b-form-group label="Surname" label-for="Surname" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="travellers.item.surname"
                                                    placeholder="Surname" size="sm" :disabled="false"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" :disabled="false" variant="outline-secondary"
                                                        @click="travellers.item.surname = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="3" xl="3">
                                        <b-form-group label="Firstname" label-for="Firstname" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="travellers.item.firstname"
                                                    placeholder="Firstname" size="sm" :disabled="false"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" :disabled="false" variant="outline-secondary"
                                                        @click="travellers.item.firstname = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="3" xl="3">
                                        <b-form-group label="Title" label-for="Title" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="travellers.item.title"
                                                    placeholder="Title" size="sm" :disabled="false"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" :disabled="false" variant="outline-secondary"
                                                        @click="travellers.item.title = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="3" xl="3">
                                        <b-form-group label="DOB" label-for="DOB" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="travellers.item.dob"
                                                    placeholder="DOB" size="sm" :disabled="false"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" :disabled="false" variant="outline-secondary"
                                                        @click="travellers.item.dob = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="3" xl="3">
                                        <b-form-group label="MOB" label-for="MOB" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="travellers.item.mob"
                                                    placeholder="MOB" size="sm" :disabled="false"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" :disabled="false" variant="outline-secondary"
                                                        @click="travellers.item.mob = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>

                                    <b-col cols="12" sm="6" md="3" xl="3">
                                        <b-form-group label="Pax Type" label-for="Pax Type" label-cols="12">
                                            <treeselect v-model="travellers.item.paxtype" :clearable="true"
                                                :options="options_paxtype" :disabled="false" placeholder="Show all...">
                                            </treeselect>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="3" xl="3">
                                        <b-row>
                                            <b-col cols="6">
                                                <b-form-group label="SabreNo" label-for="SabreNo" label-cols="12">
                                                    <b-input-group>
                                                        <b-form-input type="text"
                                                            v-model="travellers.item.sabrenamenumber"
                                                            placeholder="SabreNo" size="sm"
                                                            :disabled="false"></b-form-input>
                                                        <b-input-group-append>
                                                            <b-button size="sm" :disabled="false"
                                                                variant="outline-secondary"
                                                                @click="travellers.item.sabrenamenumber = ''">
                                                                <i class="fa fa-remove"></i>
                                                            </b-button>
                                                        </b-input-group-append>
                                                    </b-input-group>
                                                </b-form-group>
                                            </b-col>
                                            <b-col cols="6">
                                                <b-form-group label="TravellerNo" label-for="TravellerNo"
                                                    label-cols="12">
                                                    <b-input-group>
                                                        <b-form-input type="text"
                                                            v-model="travellers.item.travellernumber"
                                                            placeholder="TravellerNo" size="sm"
                                                            :disabled="false"></b-form-input>
                                                        <b-input-group-append>
                                                            <b-button size="sm" :disabled="false"
                                                                variant="outline-secondary"
                                                                @click="travellers.item.travellernumber = ''">
                                                                <i class="fa fa-remove"></i>
                                                            </b-button>
                                                        </b-input-group-append>
                                                    </b-input-group>
                                                </b-form-group>
                                            </b-col>

                                        </b-row>
                                    </b-col>

                                </b-row>

                                <div v-if="component">
                                    <component :is="component" :selection="travellers.selected" :config="cconfig"
                                        @saveit="saveit" @discard="toolClick('discard')"
                                        @refresh="toolClick('refresh')">
                                    </component>
                                </div>

                            </b-tab>

                            <b-tab>
                                <template #title>
                                    <div class="badgecontainer pr-2 mr-1">
                                        <i class="fa fa-globe text-primary mr-1"></i>
                                        Segments
                                        <b-badge id="badge-segments" variant="primary" class="edit_tab">
                                            {{ segments_count }}</b-badge>
                                    </div>

                                </template>
                                <div v-if="segments.pastespecial">
                                    <b-row class="mt-2" no-gutters>
                                        <b-col cols="auto">
                                            <b-form-group>
                                                <b-form-checkbox-group id="segments_paste_selected"
                                                    v-model="segments.paste_selected" :options="segments.paste_options"
                                                    value-field="id" text-field="label"></b-form-checkbox-group>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="auto">
                                            <b-form-group label="" label-for="Group" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="segmentgroup" placeholder="Group"
                                                        class="xs" size="sm" :disabled="false"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" :disabled="false" class="xs"
                                                            variant="outline-secondary" @click="segmentgroup = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="auto" class="text-right ml-auto">
                                            <b-row>
                                                <b-col cols="auto">
                                                    <b-link size="sm" variant="outline-primary" @click="segments_tab()">
                                                        {tab}
                                                    </b-link>
                                                </b-col>
                                                <b-col cols="auto">
                                                    <b-link size="sm" variant="outline-primary"
                                                        @click="segments_headers()">
                                                        Headers
                                                    </b-link>
                                                </b-col>
                                                <!-- <b-col>
                                                    <b-link size="sm" variant="outline-primary" @click="segments_filter()">
                                                        Formatter
                                                    </b-link>
                                                </b-col> -->
                                                <b-col>
                                                    <b-link size="sm" variant="outline-primary"
                                                        @click="segments_paste_read()">
                                                        <i class="fa fa-magic"></i>
                                                        Read It
                                                    </b-link>
                                                </b-col>
                                            </b-row>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="12">
                                            <b-form-group label-cols="12">
                                                <b-form-textarea id="data" v-model="segments.paste"
                                                    placeholder="Paste segment data" rows="6"
                                                    class="smalltextarea courier"></b-form-textarea>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                </div>

                                <b-row>
                                    <b-col>
                                        <d-table classdivtable="availtable datatable nested" refid="segments"
                                            :icon="segments.icon" :busy="segments.busy" :tools="segments.tools"
                                            :badges="segments.badges" :toolbarlibrary="segments.toolbarlibrary"
                                            :icons="segments.icons" :fields="segments.fields" :items="segments.items"
                                            :page="segments.page" :showpages="false" @load="segments_load"
                                            @click="segments_click" @select="segments_select" :tableheight="230">
                                        </d-table>
                                    </b-col>
                                </b-row>

                                <b-row v-if="segments.edit" class="mt-3">

                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-row>
                                            <b-col> <b-form-group label-cols="12" label="Source" label-size="sm">
                                                    <b-input-group>
                                                        <b-form-input v-model="item.source" :disabled="true"
                                                            :debounce="segments.debounce" placeholder="Source"
                                                            trim></b-form-input>
                                                        <b-input-group-append>
                                                            <b-button size="sm" variant="outline-secondary" @click="
                                                                item.source = ''
                                                                " :disabled="true">
                                                                <i class="fa fa-remove"></i>
                                                            </b-button>
                                                        </b-input-group-append>
                                                    </b-input-group>
                                                </b-form-group></b-col>
                                            <b-col> <b-form-group label-cols="12" label="Type" label-size="sm">
                                                    <b-input-group>
                                                        <b-form-input v-model="segments.item.type" :disabled="true"
                                                            :debounce="segments.debounce" placeholder="Type"
                                                            trim></b-form-input>
                                                        <b-input-group-append>
                                                            <b-button size="sm" variant="outline-secondary" @click="
                                                                segments.item.type = ''
                                                                " :disabled="true">
                                                                <i class="fa fa-remove"></i>
                                                            </b-button>
                                                        </b-input-group-append>
                                                    </b-input-group>
                                                </b-form-group></b-col>

                                        </b-row>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3"><b-form-group label-cols="12"
                                            label="Segment No" label-size="sm">
                                            <b-input-group>
                                                <b-form-input v-model="segments.item.segmentno"
                                                    :debounce="segments.debounce" placeholder="SegmentNo"
                                                    trim></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary" @click="
                                                        segments.item.segmentno = ''
                                                        ">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group></b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3"><b-form-group label-cols="12"
                                            label="Segment Name" label-size="sm">
                                            <b-input-group>
                                                <b-form-input v-model="segments.item.segmentname"
                                                    :debounce="segments.debounce" placeholder="Segment Name"
                                                    trim></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary" @click="
                                                        segments.item.segmentname = ''
                                                        ">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group></b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3"><b-form-group label-cols="12"
                                            label="Segment Group" label-size="sm">
                                            <b-input-group>
                                                <b-form-input v-model="segments.item.segmentgroup"
                                                    :debounce="segments.debounce" placeholder="Segment Group"
                                                    trim></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary" @click="
                                                        segments.item.segmentgroup = ''
                                                        ">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group></b-col>

                                </b-row>
                                <b-row v-if="segments.edit">
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label-cols="12" label="Start City" label-size="sm">
                                            <treeselect placeholder="Select city..."
                                                searchPromptText="Type at least 3 chars..."
                                                v-model="segments.item.startcity" :disabled="false" :clearable="true"
                                                :async="true" :load-options="treeselect_loadIATA" :show-count="true"
                                                :flatten-search-results="true" :disable-branch-nodes="true"
                                                :matchKeys="['id']" :title="segments.item.startcity +
                                                    ' ( ' +
                                                    segments.item.startcityname +
                                                    ' )'
                                                    " search-nested>
                                                <div slot="value-label" slot-scope="{ node }">
                                                    {{ node.raw.id }} (
                                                    {{ segments.item.startcityname }} )
                                                </div>
                                            </treeselect>
                                        </b-form-group>

                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label-cols="12" label="Start DateTime" label-size="sm">
                                            <b-input-group>
                                                <daterangepicker style="width:auto !important" size="sm" ref="date"
                                                    v-model="segments.datestart"
                                                    @update="segments_update('datestart', $event)" :disabled="false"
                                                    :opens="'right'" :single-date-picker="'single'" :locale-data="{
                                                        direction: 'ltr',
                                                        format: 'dd/mm/yy HH:MM',
                                                        daysOfWeek: [
                                                            'Sun',
                                                            'Mon',
                                                            'Tue',
                                                            'Wed',
                                                            'Thu',
                                                            'Fri',
                                                            'Sat',
                                                        ],
                                                        monthNames: [
                                                            'January',
                                                            'February',
                                                            'March',
                                                            'April',
                                                            'May',
                                                            'June',
                                                            'July',
                                                            'August',
                                                            'September',
                                                            'October',
                                                            'November',
                                                            'December',
                                                        ],
                                                        firstDay: 1,
                                                    }" :ranges="false" :showDropdowns="true" :linkedCalendars="true" :timePicker="true"
                                                    :timePicker24Hour="true" :time-picker-increment="1">
                                                </daterangepicker>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary" :disabled="false"
                                                        @click="
                                                            datestart = {
                                                                startDate: null,
                                                                endDate: null,
                                                            }
                                                            ">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label-cols="12" label="End DateTime" label-size="sm">
                                            <b-input-group class="treeselect_all justify-content-end pr-2px">
                                                <span style="padding-top: 0.3em" class="text-primary"
                                                    id="sameasstart-tooltip">Same As Start</span>
                                                <b-form-checkbox id="sameasstart" v-model="segments.datesameasstart"
                                                    class="z-0">
                                                </b-form-checkbox>
                                            </b-input-group>
                                            <b-input-group>
                                                <daterangepicker style="width:auto !important" size="sm" ref="date"
                                                    v-model="segments.dateend"
                                                    @update="segments_update('dateend', $event)"
                                                    :disabled="segments.datesameasstart" :opens="'right'"
                                                    :single-date-picker="'single'" :locale-data="{
                                                        direction: 'ltr',
                                                        format: 'dd/mm/yy HH:MM',
                                                        daysOfWeek: [
                                                            'Sun',
                                                            'Mon',
                                                            'Tue',
                                                            'Wed',
                                                            'Thu',
                                                            'Fri',
                                                            'Sat',
                                                        ],
                                                        monthNames: [
                                                            'January',
                                                            'February',
                                                            'March',
                                                            'April',
                                                            'May',
                                                            'June',
                                                            'July',
                                                            'August',
                                                            'September',
                                                            'October',
                                                            'November',
                                                            'December',
                                                        ],
                                                        firstDay: 1,
                                                    }" :ranges="false" :showDropdowns="true" :linkedCalendars="true" :timePicker="true"
                                                    :timePicker24Hour="true" :time-picker-increment="1">
                                                </daterangepicker>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary" :disabled="false"
                                                        @click="
                                                            dateend = {
                                                                startDate: null,
                                                                endDate: null,
                                                            }
                                                            ">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label-cols="12" label="End City" label-size="sm">
                                            <treeselect placeholder="Select city..."
                                                searchPromptText="Type at least 3 chars..."
                                                v-model="segments.item.endcity" :disabled="false" :clearable="true"
                                                :async="true" :load-options="treeselect_loadIATA" :show-count="true"
                                                :flatten-search-results="true" :disable-branch-nodes="true"
                                                :matchKeys="['id']" :title="segments.item.endcity +
                                                    ' ( ' +
                                                    segments.item.endcityname +
                                                    ' )'
                                                    " search-nested>
                                                <div slot="value-label" slot-scope="{ node }">
                                                    {{ node.raw.id }} (
                                                    {{ segments.item.endcityname }} )
                                                </div>
                                            </treeselect>
                                        </b-form-group>

                                    </b-col>

                                    <b-col cols="12" sm="6">
                                        <b-form-group label-cols="12" label="Start Location" label-size="sm">
                                            <b-input-group>
                                                <b-form-input v-model="segments.item.startlocation" :disabled="false"
                                                    :debounce="segments.debounce" placeholder="Start Location"
                                                    trim></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary" @click="
                                                        segments.item.startlocation = ''
                                                        " :disabled="false">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6">
                                        <b-form-group label-cols="12" label="End Location" label-size="sm">
                                            <b-input-group>
                                                <b-form-input v-model="segments.item.endlocation" :disabled="false"
                                                    :debounce="segments.debounce" placeholder="End Location"
                                                    trim></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary" @click="
                                                        segments.item.endlocation = ''
                                                        " :disabled="false">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label-cols="12" label="Route" label-size="sm">
                                            <b-input-group>
                                                <b-form-input v-model="segments.item.route" :disabled="false"
                                                    :debounce="segments.debounce" placeholder="Route"
                                                    trim></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary" @click="
                                                        segments.item.route = ''
                                                        " :disabled="false">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col>
                                        <b-form-group id="cabinco2" label-cols="12" label="Cabin CO2" label-size="sm">
                                            <b-input-group class="treeselect_all" style="left:65px; top:-15px">
                                                <i class="fa fa-leaf text-primary"></i>
                                            </b-input-group>
                                            <b-tooltip target="cabinco2" triggers="hover" placement="bottom">Required
                                                field for
                                                Carbon</b-tooltip>
                                            <treeselect placeholder="Cabin CO2" v-model="segments.item.cabin"
                                                :clearable="false" :multiple="false" :options="options_cabin"
                                                :matchKeys="['id']" :disabled="false">
                                                <div slot="value-label" slot-scope="{ node }">
                                                    {{ node.raw.id }}
                                                </div>
                                            </treeselect>
                                        </b-form-group>

                                    </b-col>
                                    <!-- <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label-cols="12" label="Cabin CO2" label-size="sm">
                                            <b-input-group class="treeselect_all" style="left:65px; top:-15px">
                                                    <i class="fa fa-leaf text-primary"></i>
                                                </b-input-group>
                                                <b-tooltip target="cabinco2" triggers="hover" placement="bottom">Required
                                                    field for
                                                    Carbon</b-tooltip>
                                            <b-input-group>
                                                <b-form-input v-model="segments.item.cabin" :disabled="false"
                                                    :debounce="segments.debounce" placeholder="Cabin" trim></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary" @click="
                                                        segments.item.cabin = ''
                                                        " :disabled="false">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col> -->

                                    <b-col id="equipmentco2" cols="12" sm="6" md="4" xl="3">
                                        <b-form-group v-if="item.type == 'CAR'" label-cols="12"
                                            label="Equipment (SIPP) CO2" label-size="sm">
                                            <b-input-group class="treeselect_all" style="left:120px; top:-15px">
                                                <i class="fa fa-leaf text-primary"></i>
                                            </b-input-group>
                                            <treeselect placeholder="Equipment (SIPP)" v-model="segments.item.equipment"
                                                :clearable="false" :multiple="false" :disabled="false"
                                                :options="options_cartypecode" :matchKeys="['id']">
                                                <div slot="value-label" slot-scope="{ node }">
                                                    {{ node.raw.id }}
                                                </div>
                                            </treeselect>
                                        </b-form-group>
                                        <b-form-group v-if="item.type == 'AIR'" label-cols="12"
                                            label="Equipment (aircraft) CO2" label-size="sm">
                                            <b-input-group class="treeselect_all" style="left:140px; top:-15px">
                                                <i class="fa fa-leaf text-primary"></i>
                                            </b-input-group>
                                            <treeselect :disabled="false" placeholder="Equipment (aircraft)"
                                                v-model="segments.item.equipment" :clearable="false"
                                                :options="options_aircraft">
                                                <div slot="value-label" slot-scope="{ node }">
                                                    {{ node.raw.id }}
                                                </div>
                                            </treeselect>
                                        </b-form-group>
                                        <b-form-group v-if="item.type == 'XFR'" label-cols="12" label="Equipment"
                                            label-size="sm">
                                            <b-input-group class="treeselect_all" style="left:90px; top:-15px">
                                                <i class="fa fa-leaf text-primary"></i>
                                            </b-input-group>
                                            <treeselect :disabled="false" placeholder="Equipment"
                                                v-model="segments.item.equipment" :clearable="false"
                                                :options="options_transferequipments">
                                                <div slot="value-label" slot-scope="{ node }">
                                                    {{ node.raw.id }}
                                                </div>
                                            </treeselect>
                                        </b-form-group>
                                        <b-form-group
                                            v-if="item.type !== 'AIR' && item.type !== 'CAR' && item.type !== 'XFR'"
                                            label-cols="12" label="Equipment CO2" label-size="sm">
                                            <b-input-group class="treeselect_all" style="left:90px; top:-15px">
                                                <i class="fa fa-leaf text-primary"></i>
                                            </b-input-group>
                                            <b-input-group>
                                                <b-form-input :disabled="false" v-model="segments.item.equipment"
                                                    :debounce="options.debounce" placeholder="Equipment"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary" :disabled="false"
                                                        @click="segments.item.equipment = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                        <b-tooltip target="equipmentco2" triggers="hover" placement="bottom">Required
                                            field for
                                            Carbon</b-tooltip>
                                    </b-col>

                                    <!-- <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label-cols="12" label="Equipment CO2" label-size="sm">
                                            <b-input-group class="treeselect_all" style="left:90px; top:-15px">
                                                    <i class="fa fa-leaf text-primary"></i>
                                                </b-input-group>
                                            <b-input-group>
                                                <b-form-input v-model="segments.item.equipment" :disabled="false"
                                                    :debounce="segments.debounce" placeholder="Equipment"
                                                    trim></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary" @click="
                                                        segments.item.equipment = ''
                                                        " :disabled="false">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col> -->


                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label-cols="12" label="Class Code" label-size="sm">
                                            <b-input-group>
                                                <b-form-input v-model="segments.item.classcode" :disabled="false"
                                                    :debounce="segments.debounce" placeholder="Class Code"
                                                    trim></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary" @click="
                                                        segments.item.classcode = ''
                                                        " :disabled="false">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>

                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label-cols="12" label="Classname" label-size="sm">
                                            <b-input-group>
                                                <b-form-input v-model="segments.item.classname" :disabled="false"
                                                    :debounce="segments.debounce" placeholder="Classname"
                                                    trim></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary" @click="
                                                        segments.item.classname = ''
                                                        " :disabled="false">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label-cols="12" label="Days" label-size="sm">
                                            <b-input-group>
                                                <b-form-input v-model="segments.item.days" :disabled="false"
                                                    :debounce="segments.debounce" placeholder="Days"
                                                    trim></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary" @click="
                                                        segments.item.days = ''
                                                        " :disabled="false">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>

                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label-cols="12" label="Duration" label-size="sm">
                                            <b-input-group>
                                                <b-form-input v-model="segments.item.duration" :disabled="false"
                                                    :debounce="segments.debounce" placeholder="Duration"
                                                    trim></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary" @click="
                                                        segments.item.duration = ''
                                                        " :disabled="false">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>

                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label-cols="12" label="Distance" label-size="sm">
                                            <b-input-group>
                                                <b-form-input v-model="segments.item.distance" :disabled="false"
                                                    :debounce="segments.debounce" placeholder="Distance"
                                                    trim></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary" @click="
                                                        segments.item.distance = ''
                                                        " :disabled="false">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>

                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label-cols="12" label="Vendor Locator" label-size="sm">
                                            <b-input-group>
                                                <b-form-input v-model="segments.item.vendorlocator" :disabled="false"
                                                    :debounce="segments.debounce" placeholder="Locator"
                                                    trim></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary" @click="
                                                        segments.item.vendorlocator = ''
                                                        " :disabled="false">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label-cols="12" label="Vendor" label-size="sm">
                                            <b-input-group>
                                                <b-form-input v-model="segments.item.vendorcode" :disabled="false"
                                                    :debounce="segments.debounce" placeholder="Vendor"
                                                    trim></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary" @click="
                                                        segments.item.vendorcode = ''
                                                        " :disabled="false">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label-cols="12" label="Status" label-size="sm">
                                            <treeselect placeholder="Status" v-model="segments.item.status"
                                                :clearable="false" :multiple="false" :options="options_status"
                                                :matchKeys="['id']" :disabled="readonly">
                                                <div slot="value-label" slot-scope="{ node }">
                                                    {{ node.raw.id }} | {{ node.raw.label }}
                                                </div>
                                            </treeselect>
                                        </b-form-group>
                                    </b-col>

                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label-cols="12" label="Supplier BL A/C" label-size="sm">
                                            <treeselect placeholder="Select blac..."
                                                searchPromptText="Type at least 3 chars..." v-model="segments.item.blac"
                                                :clearable="true" :async="true" :load-options="treeselect_loadBLAC"
                                                :show-count="true" :flatten-search-results="true"
                                                :disable-branch-nodes="true" :matchKeys="['id']" search-nested
                                                :disabled="!user.permissions.includes('bookings.save')">
                                                <div slot="value-label" slot-scope="{ node }">
                                                    {{ node.raw.id }}
                                                </div>
                                            </treeselect>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">

                                        <b-form-group label-cols="12" label="Payment Method" label-size="sm">
                                            <b-input-group>
                                                <treeselect placeholder="Payment Method" v-model="item.payby"
                                                    :clearable="true" :multiple="false" :options="payby_options"
                                                    :matchKeys="['id']">
                                                    <div slot="value-label" slot-scope="{ node }">
                                                        {{ node.raw.id }}
                                                    </div>
                                                </treeselect>
                                            </b-input-group> </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label-cols="12" label="Fare" label-size="sm">
                                            <b-input-group>
                                                <b-form-input v-model="segments.item.fare" :disabled="false"
                                                    :debounce="segments.debounce" placeholder="Fare"
                                                    trim></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary" @click="
                                                        segments.item.fare = ''
                                                        " :disabled="false">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>

                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label-cols="12" label="Tax" label-size="sm">
                                            <b-input-group>
                                                <b-form-input v-model="segments.item.tax" :disabled="false"
                                                    :debounce="segments.debounce" placeholder="Tax" trim></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary" @click="
                                                        segments.item.tax = ''
                                                        " :disabled="false">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label-cols="12" label="Total" label-size="sm">
                                            <b-input-group>
                                                <b-form-input v-model="segments.item.total" :disabled="false"
                                                    :debounce="segments.debounce" placeholder="Total"
                                                    trim></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary" @click="
                                                        segments.item.total = ''
                                                        " :disabled="false">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3"><b-form-group label-cols="12" label="Seats"
                                            label-size="sm">
                                            <b-input-group>
                                                <b-form-input v-model="segments.item.seats"
                                                    :debounce="segments.debounce" placeholder="Seats"
                                                    trim></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary" @click="
                                                        segments.item.seats = ''
                                                        ">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group></b-col>

                                </b-row>
                                <b-row v-if="segments.edit">
                                    <b-col cols="12" sm="12" md="12" xl="12"><b-form-group label-cols="12" label="Notes"
                                            label-size="sm">
                                            <b-input-group>
                                                <b-form-input v-model="segments.item.notes"
                                                    :debounce="segments.debounce" placeholder="Notes"
                                                    trim></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary" @click="
                                                        segments.item.notes = ''
                                                        ">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group></b-col>
                                </b-row>

                                <div v-if="component">
                                    <component :is="component" :selection="segments.selected" :config="cconfig"
                                        @saveit="saveit" @discard="toolClick('discard')"
                                        @refresh="toolClick('refresh')">
                                    </component>
                                </div>
                            </b-tab>

                            <b-tab>
                                <template #title>
                                    <div class="badgecontainer pr-2 mr-1">
                                        <i class="fa fa fa-street-view text-primary mr-1"></i>
                                        Itineraries
                                        <b-badge id="badge-itineraries" variant="primary" class="edit_tab">
                                            {{ itineraries_count }}</b-badge>
                                    </div>
                                </template>

                                <b-row class="px-0">
                                    <b-col>
                                        <b-alert :show="true" variant="secondary">
                                            <b-row align-v="center" no-gutters><b-col cols="auto mr-3">
                                                    <i class="fa fa-exclamation-circle fa-2x"></i></b-col>
                                                <b-col>
                                                    <span class="h5">Itinerary layout is: {{ item.proforma_layout
                                                        }}</span>
                                                </b-col></b-row>
                                        </b-alert></b-col>
                                </b-row>

                                <div v-if="itineraries.pastespecial">
                                    <b-row class="mt-2">
                                        <b-col cols="9">
                                            <b-form-group>
                                                <b-form-checkbox-group id="itineraries_paste_selected"
                                                    v-model="itineraries.paste_selected"
                                                    :options="itineraries.paste_options" value-field="id"
                                                    text-field="label"></b-form-checkbox-group>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="auto" class="text-right ml-auto">
                                            <b-row>
                                                <b-col cols="auto">
                                                    <b-link size="sm" variant="outline-primary"
                                                        @click="itineraries_tab()">
                                                        {tab}
                                                    </b-link>
                                                </b-col>
                                                <b-col cols="auto">
                                                    <b-link size="sm" variant="outline-primary"
                                                        @click="itineraries_headers()">
                                                        Headers
                                                    </b-link>
                                                </b-col>
                                                <b-col cols="auto">
                                                    <b-link size="sm" variant="outline-primary"
                                                        @click="itineraries_filter()">
                                                        Formatter
                                                    </b-link>
                                                </b-col>
                                                <b-col cols="auto">
                                                    <b-link size="sm" variant="outline-primary"
                                                        @click="itineraries_paste_read()">
                                                        <i class="fa fa-magic"></i>
                                                        Read It
                                                    </b-link>
                                                </b-col>
                                            </b-row>

                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="12">
                                            <b-form-group label-cols="12">
                                                <b-form-textarea id="data" v-model="itineraries.paste"
                                                    placeholder="Paste itinerary data" rows="6"
                                                    class="smalltextarea courier"></b-form-textarea>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                </div>
                                <b-row>
                                    <b-col>
                                        <!-- :selectmode="'single'" -->
                                        <d-table classdivtable="availtable datatable nested" refid="itineraries"
                                            :icon="itineraries.icon" :busy="itineraries.busy" :tools="itineraries.tools"
                                            :badges="itineraries.badges" :toolbarlibrary="itineraries.toolbarlibrary"
                                            :icons="itineraries.icons" :fields="itineraries.fields"
                                            :items="itineraries.items" :page="itineraries.page" :showpages="false"
                                            @load="itineraries_load" @click="itineraries_click"
                                            @select="itineraries_select" :tableheight="230">
                                        </d-table>
                                    </b-col>
                                </b-row>
                                <div class="mt-3" v-if="!itineraries.edit">
                                    <b-row align-h="end" class="mt-2 ">
                                        <b-col cols="12" sm="6" md="3" xl="3">
                                            <b-form-group class="text-right" label="Selection Fare GBP"
                                                label-for="markup_lineprice" label-cols="12">
                                                <b-input-group>
                                                    <b-input-group-prepend>
                                                        <b-button size="sm" variant="outline-primary"
                                                            title="Apply markup"
                                                            @click="sllines_click('markup_lineprice', sllines.selected)">
                                                            <i class="fa fa-line-chart"></i>
                                                        </b-button>
                                                    </b-input-group-prepend>
                                                    <b-form-input type="text" v-model="markup_lineprice"
                                                        placeholder="Fare GBP" size="sm"
                                                        class="text-right"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            @click="markup_lineprice = '0.00'">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" sm="6" md="3" xl="3">
                                            <b-form-group class="text-right" label="Selection Fare Total GBP"
                                                label-for="markup_linesubtotal" label-cols="12">
                                                <b-input-group>
                                                    <b-input-group-prepend>
                                                        <b-button size="sm" variant="outline-primary"
                                                            title="Apply markup"
                                                            @click="sllines_click('markup_linesubtotal', sllines.selected)">
                                                            <i class="fa fa-line-chart"></i>
                                                        </b-button>
                                                    </b-input-group-prepend>
                                                    <b-form-input type="text" v-model="markup_linesubtotal"
                                                        placeholder="Fare Total GBP" size="sm"
                                                        class="text-right"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            @click="markup_linesubtotal = '0.00'">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                    <b-row align-h="end" class="mt-2 ">
                                        <b-col cols="12" sm="6" md="3" xl="3">
                                            <b-form-group class="text-right" label="Cost Total GBP"
                                                label-for="markup_costtotal" label-cols="12">
                                                <b-input-group>
                                                    <b-input-group-prepend>
                                                        <b-button size="sm" variant="outline-primary"
                                                            title="Apply markup"
                                                            @click="itineraries_click('markup_costtotal', itineraries.selected)">
                                                            <i class="fa fa-line-chart"></i>
                                                        </b-button>
                                                    </b-input-group-prepend>
                                                    <b-form-input type="text" v-model="markup_costtotal"
                                                        placeholder="Cost Total GBP" size="sm"
                                                        class="text-right"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            @click="markup_saletotal = costtotal.toFixed(2)">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                </div>

                                <div class="mt-3" v-if="itineraries.edit">
                                    <b-row>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12" label="TicketNo" label-size="sm">
                                                <b-input-group>
                                                    <b-form-input v-model="itineraries.item.associatedno"
                                                        :disabled="false" :debounce="itineraries.debounce"
                                                        placeholder="TicketNo" trim></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary" @click="
                                                            itineraries.item.associatedno = ''
                                                            " :disabled="false">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Passenger" label-for="Pax Type" label-cols="12">
                                                <treeselect v-model="itineraries.item.passenger" :clearable="false"
                                                    :options="options_passenger" :disabled="false"
                                                    placeholder="Show all...">
                                                </treeselect>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12" label="Route" label-size="sm">
                                                <b-input-group>
                                                    <b-form-input v-model="itineraries.item.route" :disabled="true"
                                                        :debounce="segments.debounce" placeholder="Route"
                                                        trim></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary" @click="
                                                            itineraries.item.route = ''
                                                            " :disabled="true">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12" label="DateTravel" label-size="sm"
                                                :disabled="true">
                                                <b-input-group>
                                                    <b-form-input :value="itineraries.item.start_at
                                                        ? this.$helpers.datetimefield(itineraries.item.start_at)
                                                        : null
                                                        "></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            @click="itineraries.item.start_at = null">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <!-- <b-col cols="12" sm="9" md="9" xl="9">
                                            <b-form-group label-cols="12" label="More Info" label-size="sm">
                                                <treeselect v-model="itineraries.item.segmentno.split(',')" :multiple="true"
                                                    :clearable="true" :options="options_segments" :disabled="false"
                                                    placeholder="Show all...">
                                                </treeselect>
                                            </b-form-group>
                                        </b-col> -->

                                        <b-col cols="12" sm="9" md="9" xl="9">
                                            <b-form-group label-cols="12" label="More Info" label-size="sm"
                                                class="mb-0">
                                                <b-input-group class="treeselect_all justify-content-end pr-2px">
                                                    <span style="padding-top: 0.3em" class="text-primary"
                                                        id="inputlist-tooltip">Input</span>
                                                    <b-form-checkbox id="inputlist" v-model="itinerary_segments_input"
                                                        class="z-0">
                                                    </b-form-checkbox>
                                                </b-input-group>
                                                <b-input-group v-if="!itinerary_segments_input">
                                                    <treeselect v-model="itinerary_segments" :multiple="true"
                                                        :clearable="true" :options="options_segments" :disabled="false"
                                                        placeholder="Show all...">
                                                    </treeselect>
                                                </b-input-group>
                                            </b-form-group>
                                            <b-input-group v-if="itinerary_segments_input">
                                                <b-form-input v-model="itineraries.item.segmentno" :disabled="false"
                                                    :debounce="itineraries.debounce" placeholder="More Info"
                                                    trim></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary" @click="
                                                        itineraries.item.segmentno = ''
                                                        " :disabled="false">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>

                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12" label="Remark" label-size="sm">
                                                <b-input-group>
                                                    <b-form-input v-model="itineraries.item.confirmno" :disabled="false"
                                                        :debounce="segments.debounce" placeholder="Remark"
                                                        trim></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary" @click="
                                                            itineraries.item.confirmno = ''
                                                            " :disabled="false">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>


                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12" label="Fare" label-size="sm">
                                                <b-input-group>
                                                    <b-form-input v-model="itineraries.item.fare" :disabled="false"
                                                        :debounce="itineraries.debounce" placeholder="Fare"
                                                        trim></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary" @click="
                                                            itineraries.item.fare = ''
                                                            " :disabled="false">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12" label="Tax" label-size="sm">
                                                <b-input-group>
                                                    <b-form-input v-model="itineraries.item.tax" :disabled="false"
                                                        :debounce="itineraries.debounce" placeholder="Tax"
                                                        trim></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary" @click="
                                                            itineraries.item.tax = ''
                                                            " :disabled="false">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12" label="Total" label-size="sm">
                                                <b-input-group>
                                                    <b-form-input v-model="itineraries.item.total" :disabled="true"
                                                        :debounce="itineraries.debounce" placeholder="Total"
                                                        trim></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary" @click="
                                                            itineraries.item.total = ''
                                                            " :disabled="true">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                    </b-row>
                                </div>

                                <div v-if="component">
                                    <component :is="component" :selection="itineraries.selected" :config="cconfig"
                                        @saveit="saveit" @discard="toolClick('discard')"
                                        @refresh="toolClick('refresh')">
                                    </component>
                                </div>
                            </b-tab>

                            <b-tab>
                                <template #title alt="Accounting">
                                    <i class="fa fa-gbp text-primary mr-1"></i> Accounting
                                </template>
                                <p class="py-3 px-0">
                                    <b-row>
                                        <b-col cols="12" sm="12">
                                            <b-form-group label="Tags" label-for="tags" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="item.tags" placeholder="Tags"
                                                        size="sm" :disabled="readonly_development"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" :disabled="readonly_development"
                                                            variant="outline-secondary" @click="item.tags = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                        <!-- <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12" label="Cost Centre" label-size="sm">
                                                <b-input-group>
                                                    <b-form-input v-model="item.costcentre" :debounce="options.debounce"
                                                        placeholder="Cost Centre" :disabled="readonly"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            :disabled="readonly" @click="item.costcentre = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12" label="Department" label-size="sm">
                                                <b-input-group>
                                                    <b-form-input v-model="item.department" :debounce="options.debounce"
                                                        placeholder="Department" :disabled="readonly"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            :disabled="readonly" @click="item.department = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12" label="Group Code 1" label-size="sm">
                                                <b-input-group>
                                                    <b-form-input v-model="item.groupcode1" :debounce="options.debounce"
                                                        placeholder="Group Code 1" :disabled="readonly"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            :disabled="readonly" @click="item.groupcode1 = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12" label="Group Code 2" label-size="sm">
                                                <b-input-group>
                                                    <b-form-input v-model="item.groupcode2" :debounce="options.debounce"
                                                        placeholder="Group Code 2" :disabled="readonly"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            :disabled="readonly" @click="item.groupcode2 = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12" label="Group Code 3" label-size="sm">
                                                <b-input-group>
                                                    <b-form-input v-model="item.groupcode3" :debounce="options.debounce"
                                                        placeholder="Group Code 3" :disabled="readonly"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            :disabled="readonly" @click="item.groupcode3 = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col> -->

                                    </b-row>
                                    <!-- <b-row>
                                        <b-col cols="12">
                                            <b-form-group label="PNR" label-for="pnr" label-cols="12">
                                                <b-form-textarea id="pnr" v-model="item.pnr" placeholder="PNR" rows="12"
                                                    class="smalltextarea courier"></b-form-textarea>
                                            </b-form-group>
                                        </b-col>
                                    </b-row> -->

                                </p>
                            </b-tab>

                            <b-tab v-if="user.permissions.includes('bookings.admin')">
                                <template #title alt="PNR">
                                    <i class="fa fa-list text-primary mr-1"></i> PNR
                                </template>
                                <p class="py-3 px-0">
                                    <b-row>
                                        <b-col cols="12">
                                            <b-form-group label="PNR" label-for="pnr" label-cols="12">
                                                <b-form-textarea id="pnr" v-model="item.pnr" placeholder="PNR" rows="12"
                                                    class="smalltextarea courier"></b-form-textarea>
                                            </b-form-group> </b-col></b-row>

                                </p>
                            </b-tab>

                            <b-tab v-if="user.permissions.includes('bookings.admin')">
                                <template #title>
                                    <i class="fa fa-file-code-o text-primary mr-1"></i> XML
                                </template>
                                <p class="py-0 px-0">
                                    <b-card-body>
                                        <b-overlay :show="busy" rounded="sm">
                                            <div id="paper" class="mb-3 p-4 background-white text-secondary">
                                                <b-row>
                                                    <b-col>
                                                        <b-row align-h="end">
                                                            <b-col cols="auto ssh-pre mr-4">
                                                                <span>Received: </span>
                                                                <span>{{ $moment
                                                                    .unix(item.issued_at / 1000)
                                                                    .utc(false)
                                                                    .format('DD/MM/YYYY HH:mm:ss') }}</span>
                                                            </b-col>
                                                        </b-row>
                                                        <ssh-pre v-if="xml" language="xml"
                                                            :label="item.docno ? item.docno : item.locator"
                                                            class="large mt-6">{{
                                                                xml }}</ssh-pre>

                                                    </b-col>
                                                </b-row>
                                            </div>
                                        </b-overlay>
                                    </b-card-body>
                                </p>
                            </b-tab>


                            <b-tab v-if="user.permissions.includes('bookings.admin')">
                                <template #title>
                                    <i class="fa fa-envelope text-primary mr-1"></i>
                                    Message</template>
                                <p class="py-3 px-0">
                                    <b-row>
                                        <b-col cols="9">
                                            <b-form-group label="Subject" label-for="Subject" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="item.subject"
                                                        placeholder="Subject" size="sm"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" :disabled="true" variant="outline-secondary"
                                                            @click="item.subject = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group :disabled="readonly" label-cols="12" label="Agent"
                                                label-size="sm">
                                                <b-input-group>
                                                    <b-form-input v-model="item.agent" placeholder="Agent"
                                                        :disabled="true"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary" :disabled="true"
                                                            @click="item.agent = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="12">
                                            <b-form-group label="Message" label-for="message" label-cols="12">
                                                <b-form-textarea id="data" v-model="item.message" placeholder="Message"
                                                    rows="12" class="smalltextarea"></b-form-textarea>
                                            </b-form-group> </b-col></b-row>
                                    <b-row>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12" label="Message At" label-size="sm"
                                                :disabled="readonly">
                                                <b-input-group>
                                                    <b-form-input :value="item.message_at
                                                        ? this.$helpers.datefield(item.message_at)
                                                        : null
                                                        " :disabled="readonly" placeholder="Message At"></b-form-input>

                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            @click="item.message_at = null">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>

                                </p>
                            </b-tab>


                            <b-tab v-if="user.permissions.includes('bookings.admin')">
                                <template #title>
                                    <i class="fa fa-comments-o text-primary mr-1"></i>
                                    Notes</template>
                                <p class="py-3 px-0">
                                    <b-row>
                                        <b-col cols="12">
                                            <b-form-group label="Notes" label-for="notes" label-cols="12">
                                                <b-form-textarea id="data" v-model="item.notes" placeholder="Notes"
                                                    rows="12" class="smalltextarea"></b-form-textarea>
                                            </b-form-group> </b-col></b-row>
                                    <b-row class="mt-1">
                                        <b-col>
                                            <b-button squared size="sm" variant="outline-primary" class="mr-1"
                                                @click="timestamp">
                                                <i class="fa fa-clock-o"></i>
                                                Add a timestamp
                                            </b-button>
                                        </b-col>
                                    </b-row>
                                </p>
                            </b-tab>

                            <b-tab v-if="idselected">
                                <template #title>
                                    <i class="fa fa-history text-primary mr-1"></i> Audit
                                </template>
                                <p class="py-3 px-0">

                                    <b-row>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Created At" label-for="created_at" label-cols="12">
                                                <b-input-group>
                                                    <b-input-group-prepend>
                                                        <b-form-datepicker size="sm" v-model="item.created_at"
                                                            button-only label-help="" locale="en-GB"
                                                            :disabled="true"></b-form-datepicker>
                                                    </b-input-group-prepend>
                                                    <b-form-input size="sm" id="date" v-model="item.created_at"
                                                        type="text" placeholder="YYYY-MM-DD" autocomplete="off"
                                                        :disabled="true"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            @click="item.created_at = null" :disabled="true">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Created By" label-for="created_by" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="item.created_by" placeholder=""
                                                        size="sm" :disabled="true"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            @click="item.created_by = ''" :disabled="true">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Updated At" label-for="updated_at" label-cols="12">
                                                <b-input-group>
                                                    <b-input-group-prepend>
                                                        <b-form-datepicker size="sm" v-model="item.updated_at"
                                                            button-only label-help="" locale="en-GB"
                                                            :disabled="true"></b-form-datepicker>
                                                    </b-input-group-prepend>
                                                    <b-form-input size="sm" id="date" v-model="item.updated_at"
                                                        type="text" placeholder="YYYY-MM-DD" autocomplete="off"
                                                        :disabled="true"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            @click="item.updated_at = null" :disabled="true">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Updated By" label-for="updated_by" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="item.updated_by" placeholder=""
                                                        size="sm" :disabled="true"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            @click="item.updated_by = ''" :disabled="true">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="ID" label-for="id" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="item.id" placeholder="" size="sm"
                                                        :disabled="true"></b-form-input>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                    <!-- <b-row>
                          <b-col cols="12">
                            <b-form-group
                              label="Data"
                              label-for="data"
                              label-cols="12"
                            >
                              <vue-json-pretty
                                :deep="1"
                                :data="JSON.parse(item.data)"
                              >
                              </vue-json-pretty>
                            </b-form-group> </b-col
                        ></b-row> -->
                                </p>
                            </b-tab>
                        </b-tabs>
                    </b-card-body>

                    <b-card-footer class="nopadding mt-2">
                        <b-row no-gutters>
                            <b-col cols="auto" class="text-left">
                                <b-button squared size="sm" variant="primary" @click="saveit()"
                                    v-if="user.permissions.includes('bookings.save')" :disabled="postit_disabled">
                                    <i class="fa fa-check"></i>
                                    Save It
                                </b-button>
                            </b-col>
                            <b-col class="text-left ml-2 mt-1">
                                <div v-if="busy">
                                    <i class="fa fa-spinner fa-spin text-primary"></i>
                                </div>
                                <div v-else>
                                    <span v-html="message"></span>
                                </div>
                            </b-col>
                            <b-col class="text-right" cols="8">
                                <b-button squared size="sm" variant="secondary" @click="$emit('discard')">
                                    <i class="fa fa-chevron-left pr-1"></i>
                                    Back
                                </b-button>
                            </b-col>
                        </b-row>
                    </b-card-footer>
                    <datalist id="list-title">
                        <option v-for="item in options_title" :key="item">{{ item }}</option>
                    </datalist>

                </b-card>
            </div>
            <!-- <b-row class="px-3">
                <b-col>
                    <b-alert :show="message ? true : false" variant="danger">
                        <b-row align-v="center" no-gutters><b-col cols="auto mr-3">
                                <i class="fa fa-exclamation-circle fa-2x"></i></b-col>
                            <b-col>
                                {{ message }}</b-col></b-row>
                    </b-alert></b-col>
            </b-row> -->
        </b-card>
    </b-overlay>
</template>

<script>
import gql from "graphql-tag";

import ExcelJS from "exceljs";
import * as fs from "file-saver";

import formatXML from "xml-formatter";
import VueJsonPretty from "vue-json-pretty";
import "vue-json-pretty/lib/styles.css";
import SshPre from "simple-syntax-highlighter";
import "simple-syntax-highlighter/dist/sshpre.css";

function tabToObjArr(text) {

    let raw = text.trim().split('"').join("")
    let allcols = raw.split("\t")

    let headers = raw.split("\n")[0].split("\t")
    let cb = headers.length - 1
    let cols = []
    for (let i = 0; i < allcols.length; i++) {
        if (i == cb) {
            let parts = allcols[i].trim().split("\n")
            for (let k = 0; k < parts.length; k++) {
                cols.push(parts[k].trim())
            }
            cb += headers.length - 1
        } else {
            cols.push(allcols[i].trim().split("\n").join(",").replace(/\s+/g, ' '))
        }
    }
    console.log('cols=', cols)

    cb = headers.length - 1
    let rows = []
    let item = {}
    let k = 0
    for (let i = 0; i < cols.length; i++) {
        if (i == cb) {
            item[headers[k]] = cols[i]
            rows.push(item)
            cb += headers.length
            item = {}
            k = 0
        } else {
            item[headers[k]] = cols[i]
            k += 1
        }
    }
    return rows;
}

function csvToArray(text) {
    let p = '', row = [''], ret = [row], i = 0, r = 0, s = !0, l;
    for (l of text) {
        if ('"' === l) {
            if (s && l === p) row[i] += l;
            s = !s;
        } else if (',' === l && s) l = row[++i] = '';
        else if ('\n' === l && s) {
            if ('\r' === p) row[i] = row[i].slice(0, -1);
            row = ret[++r] = [l = '']; i = 0;
        } else row[i] += l;
        p = l;
    }
    return ret;
};

export default {
    name: "BookingsEdit",
    components: {
        VueJsonPretty, SshPre
    },
    props: {
        parent: { type: String, default: "booking" },
    },
    async mounted() {
        this.item.agent = this.user.initials;
        if (this.parent) {
            if (this.parent != "booking") {
                this.item.type = this.parent
            }
        }

    },
    data() {
        return {
            busy: false,
            message: null,
            load_busy: false,
            locked_at: false,
            disabled: true,
            postit_disabled: false,
            multiple: true,
            showedit: true,
            unblock: false,
            markup_lineprice: "0.00",
            markup_linesubtotal: "0.00",
            markup_costtotal: "0.00",
            datestart: { startDate: null, endDate: null },
            dateend: { startDate: null, endDate: null },
            xml: null,
            line: {},
            message: "",
            segmentgroup: null,
            itinerary_segments_sameasstart: false,
            itinerary_segments_input: false,
            itinerary_segments: [],
            payby_options: [],
            options_aircraft: [],
            options_cabin: [
                { id: "ECONOMY", label: "ECONOMY" },
                { id: "PREMIUM", label: "PREMIUM" },
                { id: "BUSINESS", label: "BUSINESS" },
                { id: "FIRST", label: "FIRST" }
            ],
            options_transferequipments:
                [
                    { id: "MINIVAN", label: "MINIVAN" },
                    { id: "TAXI", label: "TAXI" },
                    { id: "MINIBUS", label: "MINIBUS" },
                    { id: "COACH", label: "COACH" }
                ],
            options_status: [
                { id: "HK", label: "Confirmed" },
                { id: "VD", label: "Void" },
            ],
            options_segmentspriced: [
                { id: false, label: "No" },
                { id: true, label: "Yes" },
            ],
            options_proformalayout: [
                { id: "bytravellers", label: "ByTravellers" },
                { id: "bysegments", label: "BySegments" },
            ],
            type_options: [
                { id: 0, label: "File" },
                { id: 1, label: "File folder" },
            ],
            options_type: [
                { id: "AIR", label: "Air Ticketed" },
                { id: "LOW", label: "Low Cost" },
                { id: "HTL", label: "Hotels" },
                { id: "CAR", label: "Cars" },
                { id: "XFR", label: "Transfers" },
                { id: "RAI", label: "Rail/Eurostar" },
                { id: "BAG", label: "Baggage" },
                { id: "MTG", label: "Meetings" },
                { id: "OTH", label: "Other" },
                // { id: "VISA", label: "VISA" },
            ],
            options_paxtype: [
                { id: "INF", label: "INFANT" },
                { id: "CHD", label: "CHILD" },
                { id: "ADT", label: "ADULT" },
            ],
            options_state: [
                { id: 0, label: "Unsubmit" },
                { id: 1, label: "Submit" },
            ],
            options_title: ["MR", "MRS", "MISS", "MS", "DR"],
            options_cartypecode: [],
            documentxml: "",
            item: {
                type: "AIR",
                status: "HK",
                cabin: "ECONOMY",
                state: 0,
                segments_priced: false,
                qty: "0",
            },
            options: {
                title: "Edit Booking",
                icon_header: "fa fa-tasks",
                icon: "fa fa-tasks",
                debounce: 500,
                actions_as_elipses: false,
                modal: {},
                component: {},
                overlay_show: false,
                overlay: {},
            },
            travellers: {
                busy: false,
                debounce: 500,
                title: "Travellers",
                icon: "fa fa-user text-primary",
                edit: false,
                pastespecial: false,
                paste: null,
                paste_selected: ["replace", "firstrowheader", "reversenamecap"],
                paste_options: [{ id: "replace", label: "Replace" }, { id: "firstrowheader", label: "First Row Headers", disabled: true }, { id: "reversenamecap", label: "Reverse Name Capitalise" }],
                tools: "go,export,clipboard,reset,add,edit,clone,pastespecial,deleteconfirm,up,down,top",
                fields: [
                    {
                        key: "selected",
                        label: "...",
                        class: "text-center",
                    },
                    {
                        key: "icon",
                        label: "",
                        class: "text-right w-50px",
                    },
                    {
                        key: "passenger",
                        label: "Passenger",
                        class: "text-center",
                    },
                    {
                        key: "surname",
                        label: "Surname",
                        class: "text-center",
                    },
                    {
                        key: "firstname",
                        label: "Firstname",
                        class: "text-center",
                    },
                    {
                        key: "title",
                        label: "Title",
                        class: "text-center",
                    },
                    // ON ITINERARIES
                    // {
                    //     key: "associatedno",
                    //     label: "TicketNo",
                    //     class: "text-center",
                    // },
                    {
                        key: "paxtype",
                        label: "Pax Type",
                        class: "text-center",
                    },
                    {
                        key: "dob",
                        label: "DOB",
                        class: "text-center",
                    },
                    {
                        key: "mob",
                        label: "MOB",
                        class: "text-center",
                    },
                    {
                        key: "sabrenamenumber",
                        label: "Sabre No",
                    },
                    {
                        key: "travellernumber",
                        label: "Traveller No",
                    },
                    {
                        key: "actions",
                        label: "Actions",
                        class: "actions w-110px",
                    },

                ],
                badges: [],
                item: {},
                items: [],
                selected: [],
            },
            segments: {
                busy: false,
                debounce: 500,
                title: "Segments",
                icon: "fa fa-globe text-primary",
                edit: false,
                pastespecial: false,
                paste: null,
                paste_selected: ["firstrowheader", "reversenamecap"],
                paste_options: [
                    { id: "firstrowheader", label: "First Row Headers", disabled: true },
                    { id: "secondrowskip", label: "Second Row Skip" },
                    { id: "filldown", label: "Fill Down" },
                ],
                datesameasstart: true,
                datestart: { startDate: null, endDate: null },
                dateend: { startDate: null, endDate: null },
                tools: "go,export,clipboard,reset,add,edit,clone,pastespecial,deleteconfirm,up,down,top",
                fields: [
                    {
                        key: "selected",
                        label: "...",
                        class: "text-center",
                    },
                    {
                        key: "icon",
                        label: "",
                        class: "text-right w-50px",
                    },
                    {
                        key: "segmentno",
                        label: "No",
                        sortable: true,
                    },
                    {
                        key: "segmentgroup",
                        label: "Group",
                        sortable: true,
                        formatter: (value, key, item) => {
                            let result = value;
                            if (result) {
                                if (result.length > 20) {
                                    result = result.slice(0, 17) + "...";
                                }
                            }
                            return result;
                        },
                    },
                    {
                        key: "segmentname",
                        label: "Name",
                        sortable: true,
                        formatter: (value, key, item) => {
                            let result = value;
                            if (result) {
                                if (result.length > 20) {
                                    result = result.slice(0, 17) + "...";
                                }
                            }
                            return result;
                        },
                    },
                    {
                        key: "startcity",
                        label: "Start City",
                        sortable: true,
                    },
                    {
                        key: "startlocation",
                        label: "Start Location",
                        sortable: true,
                        formatter: (value, key, item) => {
                            let result = value;
                            if (result) {
                                if (result.length > 20) {
                                    result = result.slice(0, 17) + "...";
                                }
                            }
                            return result;
                        },
                    },
                    {
                        key: "start_at",
                        label: "Start DateTime",
                        sortable: true,
                        formatter: (value, key, item) => {
                            let result = "";
                            if (value) {
                                result = this.$moment
                                    .unix(value / 1000)
                                    .utc(false)
                                    .format("DD/MM/YYYY HH:mm:SS");
                            }
                            return result;
                        },
                    },
                    {
                        key: "end_at",
                        label: "End DateTime",
                        sortable: true,
                        formatter: (value, key, item) => {
                            let result = "";
                            if (value) {
                                result = this.$moment
                                    .unix(value / 1000)
                                    .utc(false)
                                    .format("DD/MM/YYYY HH:mm:SS");
                            }
                            return result;
                        },
                    },
                    {
                        key: "endlocation",
                        label: "End Location",
                        sortable: true,
                        formatter: (value, key, item) => {
                            let result = value;
                            if (result) {
                                if (result.length > 20) {
                                    result = result.slice(0, 17) + "...";
                                }
                            }
                            return result;
                        },
                    },
                    {
                        key: "endcity",
                        label: "End City",
                        sortable: true,
                    },
                    {
                        key: "equipment",
                        label: "Equipment CO2",
                        class: "text-center",
                        clearable: "true",
                    },
                    {
                        key: "cabin",
                        label: "Cabin CO2",
                        class: "text-center",
                        clearable: "true",
                    },
                    {
                        key: "classcode",
                        label: "Class",
                        class: "text-center",
                        clearable: "true",
                    },
                    {
                        key: "classname",
                        label: "Classname",
                        class: "text-center",
                        clearable: "true",
                    },
                    {
                        key: "seats",
                        label: "Seats",
                        class: "text-center",
                        clearable: "true",
                    },
                    {
                        key: "vendorcode",
                        label: "Vendor",
                        class: "text-center",
                        clearable: "true",
                    },
                    {
                        key: "fare",
                        label: "Fare",
                        sortable: true,
                        class: "text-right",
                        totalled: true,
                        total: 0,
                    },
                    {
                        key: "tax",
                        label: "Tax",
                        sortable: true,
                        class: "text-right",
                        totalled: true,
                        total: 0,
                    },
                    {
                        key: "actions",
                        label: "Actions",
                        class: "actions w-110px",
                    },
                ],
                icons: [
                    {
                        key: "type",
                        AIR: "fa fa-plane text-primary w-15px text-center",
                        LOW: "fa fa-plane text-pink w-15px text-center",
                        HTL: "fa fa-bed text-purple w-15px text-center",
                        CAR: "fa fa-car text-info w-15px text-center",
                        XFR: "fa fa-bus text-warning w-15px text-center",
                        RAI: "fa fa-train text-danger w-15px text-center",
                        MTG: "fa fa-users text-black w-15px text-center",
                        BAG: "fa fa-suitcase text-orange w-15px text-center",
                        OTH: "fa fa-question-circle text-black w-15px text-center"
                    }
                ],
                badges: [],
                item: {},
                items: [],
                selected: [],
            },

            itineraries: {
                busy: false,
                debounce: 500,
                title: "Itineraries",
                icon: "fa fa-street-view text-primary",
                edit: false,
                pastespecial: false,
                paste: null,
                paste_selected: ["replace", "firstrowheader", "reversenamecap"],
                paste_options: [{ id: "replace", label: "Replace" }, { id: "firstrowheader", label: "First Row Headers", disabled: true },],
                toolbarlibrary: [
                    {
                        type: "button",
                        size: "sm",
                        variant: "outline-white",
                        squared: "squared",
                        icon: "fa fa-user text-danger",
                        position: "toolbar",
                        action: "itinerarybytravellers",
                        label: "ByTravellers",
                        overlay: {
                            message: "Are you sure you want to switch the itineraries to ByTravellers?",
                            buttons: [
                                {
                                    label: "Yes",
                                    variant: "danger",
                                    action: "bytravellers",
                                },
                                {
                                    label: "No",
                                    class: "ml-2",
                                },
                            ],
                        },
                    },
                    {
                        type: "button",
                        size: "sm",
                        variant: "outline-white",
                        squared: "squared",
                        icon: "fa fa-globe text-danger",
                        position: "toolbar",
                        action: "itinerarybysegments",
                        label: "BySegments",
                        overlay: {
                            message: "Are you sure you want to switch the itineraries to BySegments?",
                            buttons: [
                                {
                                    label: "Yes",
                                    variant: "danger",
                                    action: "bysegments",
                                },
                                {
                                    label: "No",
                                    class: "ml-2",
                                },
                            ],
                        },
                    },
                ],
                tools: "go,export,clipboard,reset,add,edit,clone,pastespecial,deleteconfirm,up,down,top,itinerarybytravellers,itinerarybysegments",
                fields: [
                    {
                        key: "selected",
                        label: "...",
                        class: "text-center",
                    },
                    {
                        key: "icon",
                        label: "",
                        class: "text-right w-50px",
                    },
                    {
                        key: "start_at",
                        label: "Start DateTime",
                        sortable: true,
                        formatter: (value, key, item) => {
                            let result = "";
                            if (value) {
                                result = this.$moment
                                    .unix(value / 1000)
                                    .utc(false)
                                    .format("DD/MM/YYYY HH:mm:SS");
                            }
                            return result;
                        },
                    },
                    {
                        key: "associatedno",
                        label: "Tkt/Ref",
                        class: "text-center",
                        sortable: true,
                    },
                    {
                        key: "route",
                        label: "Details",
                        class: "text-center",
                        formatter: (value, key, item) => {
                            let result = value;
                            if (result) {
                                if (result.length > 30) {
                                    result = result.slice(0, 27) + "...";
                                }
                            }
                            return result;
                        },
                    },
                    {
                        key: "passenger",
                        label: "Passenger",
                        class: "text-center",
                        formatter: (value, key, item) => {
                            let result = value;
                            if (result) {
                                if (result.length > 30) {
                                    result = result.slice(0, 27) + "...";
                                }
                            }
                            return result;
                        },
                    },
                    {
                        key: "segmentno",
                        label: "SegmentNo",
                        class: "text-center",
                        sortable: true,
                    },


                    {
                        key: "fare",
                        label: "Fare",
                        sortable: true,
                        class: "text-right",
                        totalled: true,
                        total: 0,
                    },
                    {
                        key: "tax",
                        label: "Tax",
                        sortable: true,
                        class: "text-right",
                        totalled: true,
                        total: 0,
                    },
                    {
                        key: "total",
                        label: "Total",
                        sortable: true,
                        class: "text-right",
                        totalled: true,
                        total: 0,
                    },
                    {
                        key: "actions",
                        label: "Actions",
                        class: "actions w-110px",
                    },
                ],
                icons: [
                    {
                        key: "type",
                        CAR: "fa fa-car text-info",
                        HTL: "fa fa-bed text-gray",
                        TRN: "fa fa-train text-danger",
                    }
                ],
                badges: [],
                item: {},
                items: [],
                selected: [],
            },
        };
    },
    computed: {
        readonly() {
            if (this.user.permissions.includes('bookings.save')) {
                return false //this.item.locked
            }
            return true;
        },
        options_passenger() {
            let result = []
            for (let i = 0; i < this.travellers.items.length; i++) {
                let traveller = this.travellers.items[i]
                result.push({ id: traveller.passenger, label: traveller.passenger + " | " + traveller.firstname + " " + traveller.surname }
                )
            }
            return result
        },
        options_segments() {
            let result = []
            for (let i = 0; i < this.segments.items.length; i++) {
                let segment = this.segments.items[i]
                let id = segment.segmentno ? segment.segmentno : "S" + (i + 1).toString()
                let label = id + " | " + this.$moment.unix(segment.start_at / 1000).utc(false).format("YYYY-MM-DD HH:mm") + " | " + segment.startlocation + ">" + segment.endlocation + " / GBP " + segment.fare
                result.push({ id, label }
                )
            }
            return result
        },
        travellers_count() {
            let result = 0
            if (this.travellers.items.length > 0) {
                result = this.travellers.items.length
                if (parseInt(this.item.pax) > result) {
                    result = parseInt(this.item.pax)
                }
            } else {
                result = this.item.pax
            }
            return result
        },
        segments_count() {
            let result = 0
            if (this.segments.items.length > 0) {
                result = this.segments.items.length
                if (parseInt(this.item.qty) > result) {
                    result = parseInt(this.item.qty)
                }
            } else {
                result = this.item.qty
            }
            return result
        },
        itineraries_count() {
            let result = 0
            if (this.itineraries.items.length > 0) {
                result = this.itineraries.items.length
            }
            return result
        },
        loadlabel() {
            let result = "Unknown"
            if (this.item) {
                if (this.item.type == 'AIR' || this.item.type == 'BAG') {
                    result = "GDS Locator(s) or TicketNo(s) ( 6 alpha or 10 / 13 numeric allowed )"
                }
                if (this.item.type == 'LOW') {
                    result = "GDS ConfirmNo"
                }
            }
            return result
        }
    },
    watch: {
        fileUpload: {
            immediate: true,
            deep: true,
            async handler(newVal, oldVal) {
                if (newVal) {
                    console.log("watch:fileUpload", newVal);
                }
            },

        },
        "item.name": {
            async handler(newVal, oldVal) {
                if (this.fileUpload) {
                    this.fileUpload.name = newVal;
                }
            },
        },
        "item.surname": {
            immediate: true,
            async handler(newVal, oldVal) {
                if (newVal) {
                    this.item.passenger = newVal.toUpperCase()
                    if (this.item.firstname) {
                        this.item.passenger += "/" + this.item.firstname
                    }
                }
            },
        },
        "item.firstname": {
            immediate: true,
            async handler(newVal, oldVal) {
                if (newVal) {
                    this.item.passenger = this.item.surname.toUpperCase() + "/" + newVal.toUpperCase()
                }
            },
        },
        "item.slac": {
            async handler(newVal, oldVal) {
                if (typeof newVal === "undefined") {
                    this.item.slac = ""
                }
            }
        },
        "item.eventcode": {
            async handler(newVal, oldVal) {
                if (typeof newVal === "undefined") {
                    this.item.eventcode = ""
                }
            }
        },
        "item.startcity": {
            async handler(newVal, oldVal) {
                if (typeof newVal === "undefined") {
                    this.item.startcity = ""
                }
            }
        },
        "item.endcity": {
            async handler(newVal, oldVal) {
                if (typeof newVal === "undefined") {
                    this.item.endcity = ""
                }
            }
        },
        "travellers.item.surname": {
            async handler(newVal, oldVal) {
                if (newVal) {
                    this.travellers.item.passenger = newVal.toUpperCase() + "/"
                    if (this.travellers.item.firstname) {
                        this.travellers.item.passenger += this.travellers.item.firstname
                    }
                }
            }
        },
        "travellers.item.firstname": {
            async handler(newVal, oldVal) {
                if (newVal) {
                    this.travellers.item.passenger = this.travellers.item.surname.toUpperCase() + "/" + newVal.toUpperCase()
                }
            }
        },
        "itineraries.item.segementno": {
            async handler(newVal, oldVal) {
                if (newVal) {
                    this.itinerary_segments = this.itineraries.item.segementno.split(",")
                }
            }
        },
        "itinerary_segments": {
            async handler(newVal, oldVal) {
                console.log('itinerary_segments newval=', newVal)
                if (newVal) {
                    let value = newVal.join(",")
                    if (this.itineraries.item) {
                        this.itineraries.item.segmentno = value

                        let fare = 0
                        let tax = 0
                        let total = 0
                        for (let i = 0; i < newVal.length; i++) {
                            let seg = newVal[i]
                            let found = this.segments.items.find(o => o.segmentno == seg)
                            if (found) {
                                if (this.item.segments_priced && parseFloat(found.fare) > 0 || parseFloat(found.tax) > 0) {
                                    fare += parseFloat(found.fare)
                                    tax += parseFloat(found.tax)
                                }
                            }
                        }
                        total = fare + tax
                        if (this.item.segments_priced) {
                            this.itineraries.item.fare = fare.toFixed(2)
                            this.itineraries.item.tax = tax.toFixed(2)
                            this.itineraries.item.total = total.toFixed(2)
                        }
                    }
                }
            }
        },

        "itineraries.item.fare": {
            async handler(newVal, oldVal) {
                if (newVal) {
                    this.itineraries.item.total = (parseFloat(this.itineraries.item.fare) + parseFloat(this.itineraries.item.tax)).toFixed(2)
                }
            }
        },
        "xml": {
            immediate: true,
            async handler(newVal, oldVal) {
                if (newVal) {
                    let pnr = formatXML(newVal, {
                        indentation: "  ",
                        filter: (node) => node.type !== "Comment",
                        collapseContent: true,
                        lineSeparator: "\n",
                    });
                    this.xml = pnr
                }
            }
        },

    },
    methods: {
        async load() {

            let variables = {
                id: this.idselected,
                // mssql: true,
            };
            console.log("variables", variables);

            this.busy = true;

            try {
                const response = await this.$apollo.query({
                    query: gql`
                  query bookings($id: String) {
                    bookings(id: $id) {
                        id
                        type
                        source
                        state
                        issued_at
                        details
                        subject
                        docno
                        locator                                
                        confirmno
                        associatedno                 
                        slac
                        to
                        yourref
                        booker
                        costcentre
                        department
                        groupcode1
                        groupcode2
                        groupcode3               
                        title
                        firstname
                        surname
                        passenger
                        startcity
                        startcityname
                        startlocation
                        endcity
                        endcityname
                        endlocation
                        start_at
                        end_at
                        days
                        equipment
                        cabin                
                        qty                  
                        amount                 
                        eventcode
                        status
                        bltotal
                        sltotal
                        invoiceno                
                        blac                
                        agent
                        reason
                        payby
                        tags
                        notes
                        voucherinfo
                        data
                        pnr
                        travellers {
                            passenger
                            surname
                            firstname
                            title
                            paxtype
                            dob
                            mob
                            travellernumber
                            sabrenamenumber
                        }
                        segments {
                            type
                            segmentno
                            segmentname
                            segmentgroup
                            startcity
                            startcityname
                            startlocation
                            start_at
                            end_at
                            days
                            endcity
                            endcityname
                            endlocation
                            route
                            equipment
                            cabin
                            classcode
                            classname
                            distance
                            duration
                            seats
                            vendorlocator
                            vendorcode
                            status
                            blac
                            payby
                            fare
                            tax
                            total
                            notes
                        }
                        itineraries {
                            start_at
                            associatedno
                            passenger
                            route
                            segmentno
                            confirmno
                            fare
                            tax
                            total
                        }
                        segments_priced
                        proforma_layout
                        updated_by
                        updated_at
                        created_by
                        created_at
                        locked  
                        rows
                    }
                  }
                `,
                    variables,
                });

                this.item = response.data.bookings[0];

                // if (this.item.proforma_layout == "bysegments") {
                //     this.itineraries.fields = [
                //         {
                //             key: "selected",
                //             label: "...",
                //             class: "text-center",
                //         },
                //         {
                //             key: "icon",
                //             label: "",
                //             class: "text-right w-50px",
                //         },
                //         {
                //             key: "start_at",
                //             label: "Start DateTime",
                //             sortable: true,
                //             formatter: (value, key, item) => {
                //                 let result = "";
                //                 if (value) {
                //                     result = this.$moment
                //                         .unix(value / 1000)
                //                         .utc(false)
                //                         .format("DD/MM/YYYY HH:mm:SS");
                //                 }
                //                 return result;
                //             },
                //         },
                //         {
                //             key: "associatedno",
                //             label: "Tkt/Ref",
                //             class: "text-center",
                //             sortable: true,
                //         },
                //         {
                //             key: "route",
                //             label: "Details",
                //             class: "text-center",
                //             formatter: (value, key, item) => {
                //                 let result = value;
                //                 if (result) {
                //                     if (result.length > 30) {
                //                         result = result.slice(0, 27) + "...";
                //                     }
                //                 }
                //                 return result;
                //             },
                //         },
                //         {
                //             key: "passenger",
                //             label: "Passenger",
                //             class: "text-center",
                //             formatter: (value, key, item) => {
                //                 let result = value;
                //                 if (result) {
                //                     if (result.length > 30) {
                //                         result = result.slice(0, 27) + "...";
                //                     }
                //                 }
                //                 return result;
                //             },
                //         },
                //         {
                //             key: "segmentno",
                //             label: "SegmentNo",
                //             class: "text-center",
                //             sortable: true,
                //         },


                //         {
                //             key: "equipment",
                //             label: "Equipment",
                //             class: "text-center",
                //             sortable: true,
                //         },
                //         {
                //             key: "fare",
                //             label: "Fare",
                //             sortable: true,
                //             class: "text-right",
                //             totalled: true,
                //             total: 0,
                //         },
                //         {
                //             key: "tax",
                //             label: "Tax",
                //             sortable: true,
                //             class: "text-right",
                //             totalled: true,
                //             total: 0,
                //         },
                //         {
                //             key: "total",
                //             label: "Total",
                //             sortable: true,
                //             class: "text-right",
                //             totalled: true,
                //             total: 0,
                //         },
                //         {
                //             key: "actions",
                //             label: "Actions",
                //             class: "actions w-110px",
                //         },
                //     ]
                // } else {
                //     this.itineraries.fields = [
                //         {
                //             key: "selected",
                //             label: "...",
                //             class: "text-center",
                //         },
                //         {
                //             key: "icon",
                //             label: "",
                //             class: "text-right w-50px",
                //         },
                //         {
                //             key: "start_at",
                //             label: "Start DateTime",
                //             sortable: true,
                //             formatter: (value, key, item) => {
                //                 let result = "";
                //                 if (value) {
                //                     result = this.$moment
                //                         .unix(value / 1000)
                //                         .utc(false)
                //                         .format("DD/MM/YYYY HH:mm:SS");
                //                 }
                //                 return result;
                //             },
                //         },
                //         {
                //             key: "associatedno",
                //             label: "Tkt/Ref",
                //             class: "text-center",
                //             sortable: true,
                //         },
                //         {
                //             key: "route",
                //             label: "Details",
                //             class: "text-center",
                //             formatter: (value, key, item) => {
                //                 let result = value;
                //                 if (result) {
                //                     if (result.length > 30) {
                //                         result = result.slice(0, 27) + "...";
                //                     }
                //                 }
                //                 return result;
                //             },
                //         },
                //         {
                //             key: "passenger",
                //             label: "Passenger",
                //             class: "text-center",
                //             formatter: (value, key, item) => {
                //                 let result = value;
                //                 if (result) {
                //                     if (result.length > 30) {
                //                         result = result.slice(0, 27) + "...";
                //                     }
                //                 }
                //                 return result;
                //             },
                //         },
                //         {
                //             key: "segmentno",
                //             label: "SegmentNo",
                //             class: "text-center",
                //             sortable: true,
                //         },


                //         {
                //             key: "fare",
                //             label: "Fare",
                //             sortable: true,
                //             class: "text-right",
                //             totalled: true,
                //             total: 0,
                //         },
                //         {
                //             key: "tax",
                //             label: "Tax",
                //             sortable: true,
                //             class: "text-right",
                //             totalled: true,
                //             total: 0,
                //         },
                //         {
                //             key: "total",
                //             label: "Total",
                //             sortable: true,
                //             class: "text-right",
                //             totalled: true,
                //             total: 0,
                //         },
                //         {
                //             key: "actions",
                //             label: "Actions",
                //             class: "actions w-110px",
                //         },
                //     ]
                // }

                if (this.item.start_at) {
                    let v = this.$moment.unix(this.item.start_at / 1000).utc(false).format("YYYY-MM-DD HH:mm")
                    this.datestart = { startDate: v, endDate: v }
                }
                if (this.item.end_at) {
                    let v = this.$moment.unix(this.item.end_at / 1000).utc(false).format("YYYY-MM-DD HH:mm")
                    this.dateend = { startDate: v, endDate: v }
                }

                this.xml = this.item.pnr

                this.travellers.items = this.item.travellers
                this.travellers.edit = false
                this.segments.items = this.item.segments
                this.segments.edit = false
                this.itineraries.items = this.item.itineraries
                this.itineraries.edit = false

                if (this.item.associatedno) {
                    this.item.associatedno = this.item.associatedno.split(",")
                }

                if (this.item.data) {
                    this.fileUpload = JSON.parse(this.item.data);
                }
                this.sumcosttotal()

            } catch (error) {
                console.log(error);
            }


            try {
                const response = await this.$apollo.query({
                    query: gql`
            query bookingformspaytypes {
              bookingformspaytypes {
                id
                label: name
              }
            }
          `,
                });
                this.payby_options = response.data.bookingformspaytypes;
            } catch (error) {
                console.log(error);
            }

            // LOAD OPTIONS BY TYPE
            console.log(this.item.type)
            switch (this.item.type) {

                case "CAR":
                    try {
                        const response = await this.$apollo.query({
                            query: gql`
                            query setup_carsipps {
                            setup_carsipps {
                                id
                                label
                            }
                            }
                        `,
                        });
                        this.options_cartypecode = response.data.setup_carsipps;
                    } catch (error) {
                        console.log(error);
                    }
                    break;

                case "AIR":
                    try {
                        const response = await this.$apollo.query({
                            query: gql`
                                query setup_aircrafts {
                                    setup_aircrafts {
                                    id: iatacode
                                    label
                                }
                                }
                            `,
                        });
                        this.options_aircraft = response.data.setup_aircrafts;
                    } catch (error) {
                        console.log(error);
                    }
                    break;

            }

            this.busy = false;
        },
        async saveit() {
            this.busy = true;

            let rows = [this.cleanit(this.item)];
            delete rows[0].issued_at

            rows[0].start_at = this.datestart.startDate
            rows[0].end_at = this.dateend.startDate

            if (this.item.pnr) {
                rows[0].pnr = Buffer.from(rows[0].pnr, "ascii").toString("base64");
            }
            if (this.item.associatedno) {
                rows[0].associatedno = this.item.associatedno.join(",")
            }
            if (this.travellers.items) {
                rows[0].travellers = this.travellers.items
            }
            if (this.segments.items) {
                rows[0].segments = this.segments.items
            }
            if (this.itineraries.items) {
                rows[0].itineraries = this.itineraries.items
            }

            let variables = {
                rows,
            };
            if (this.fileUpload) {
                variables.rows[0].data = JSON.stringify(this.fileUpload);
            } else {
                variables.rows[0].data = "";
            }
            console.log("variables", variables);

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
                  mutation bookings_save($rows: [Booking_input], $dateformat: String) {
                    bookings_save(rows: $rows, dateformat: $dateformat) {
                      id
                    }
                  }
                `,
                    variables,
                });
                this.message = "<span class='text-primary'>Saved it.</span>";
            } catch (error) {
                this.message = "<span class='text-danger'>" + error.message + "</span>";
            }

            this.xml = null
            await this.load()

            this.busy = false;
        },

        async load_data(data) {
            this.message = ""
            this.load_busy = true;

            let variables = {
                selected: [{
                    id: this.item.id,
                }],
                data: this.item.associatedno.join(","),
                apply: true
            }
            console.log(variables)

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
                        mutation bookings_load($selected: [Booking_input], $data: String, $apply: Boolean) {
                            bookings_load(selected: $selected, data: $data, apply: $apply ) {
                                id
                            }
                        }
                        `,
                    variables,
                });
                this.message = "Data loaded to booking"

            } catch (error) {
                this.message = error.message
                console.log(error)

            }
            await this.load()
            this.load_busy = false;
        },
        async travellers_load(offset, limit, page) {

            let state = this.travellers;

            state.busy = true;
            // state.items = [];

            // let variables = {
            //     id: this.idselected,
            // };

            // try {
            //     const response = await this.$apollo.query({
            //         query: gql`
            //             query bookings($id: String) {
            //                 bookings(id: $id) {
            //                 id
            //                 travellers{
            //                     surname
            //                     firstname
            //                     title
            //                     paxtype
            //                     associatedno
            //                     passenger
            //                     travellernumber
            //                     sabrenamenumber
            //                 }
            //             }
            //         }
            //     `,
            //         variables,
            //     });

            //     state.items = response.data.bookings[0].travellers;


            // } catch (error) {
            // }

            state.busy = false;
        },

        async travellers_click(a, ss) {
            console.log("travellers_click", a, ss);

            let state = this.travellers;

            let found = null
            let route = null

            switch (a) {
                case "go":
                    await this.load();
                    break;

                case "add":
                    state.items.push({ passenger: "", paxtype: "ADT", sabrenamenumber: (state.items.length + 1).toString() + ".1", travellernumber: (state.items.length + 1).toString() })
                    break;

                case "clone":
                    state.items.push({ ...state.item, surname: state.item.surname + "_" + state.items.length + 1, sabrenamenumber: (state.items.length + 1).toString() + ".1", travellernumber: (state.items.length + 1).toString() })
                    break;

                case "reset":
                    this.travellers.items = []
                    this.segments.items = []
                    this.itineraries.items = []
                    break;

                case "edit":
                    state.edit = !state.edit
                    break;

                case "pastespecial":
                    state.pastespecial = !state.pastespecial
                    break;

                case "delete":
                    for (let i = 0; i < ss.length; i++) {
                        found = state.items.findIndex(o => o.passenger == ss[i].passenger)
                        if (found != -1) {
                            state.items.splice(found, 1)
                        }
                    }
                    break;

                case "up":
                    for (let i = 0; i < ss.length; i++) {
                        found = state.items.findIndex(o => o.passenger == ss[i].passenger)
                        console.log(found)
                        if (found != -1) {
                            let target = found - 1
                            if (target != -1) {
                                console.log('move up', found, target, state.items.length)
                                this.moveItem(state.items, found, target)
                            }

                        }
                    }
                    break;

                case "down":
                    for (let i = 0; i < ss.length; i++) {
                        found = state.items.findIndex(o => o.passenger == ss[i].passenger)
                        console.log(found)
                        if (found != -1) {
                            let target = found + 1
                            if (target != -1) {
                                this.moveItem(state.items, found, target)
                            }

                        }
                    }
                    break;

                case "top":
                    for (let i = 0; i < ss.length; i++) {
                        found = state.items.findIndex(o => o.passenger == ss[i].passenger)
                        if (found != -1) {
                            let target = 0
                            if (target != -1) {
                                console.log('move up', found, target, state.items.length)
                                this.moveItem(state.items, found, target)
                            }

                        }
                    }
                    break;

                case "save":
                    await this.travellers_saveit()
                    break;

            }
        },

        async travellers_select(ss, tools) {
            // return
            console.log("travellers_select", ss);

            let state = this.travellers;

            state.selected = ss;
            let tool = null;

            if (tools) {
                let enabled = ["back", "go", "filter", "reset", "clipboard", "add", "export", "pastespecial"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = false;
                    }
                });
                // == 1
                enabled = ["edit", "clone", "up", "down", "top"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length == 1 ? false : true;
                    }
                });
                // > 1
                enabled = ["save", "deleteconfirm"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length > 0 ? false : true;
                    }
                });

                if (!state.denied) {
                    state.denied = [];
                }
                state.denied.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.visible = false;
                    }
                });
            }

            if (state.selected.length > 0) {
                state.item = state.selected[0]  // WHAT YOU SELECTED


                // this.datesra = this.$moment.unix(state.item.datetravel * 0.001).utc(true).format("YYYY-MM-DD")

            } else {
                state.item = {}
            }

            this.message = ""
        },

        async travellers_headers() {
            let state = this.travellers;
            let content = state.paste
            state.paste = "Name\tSurname\tFirstname\tTitle\tDOB\tMOB\n"
            if (content) {
                state.paste += content
            }
        },
        async travellers_tab() {
            let state = this.travellers;
            let content = state.paste
            state.paste += "\t"

        },
        async travellers_paste_read() {

            let state = this.travellers;

            if (state.paste) {

                try {
                    // STAGE ONE, SPLIT BY LINE
                    let rows = state.paste.split("\n")
                    for (let i = 0; i < rows.length; i++) {
                        // SPLIT BY COL
                        if (rows[i]) {
                            rows[i] = rows[i].split("\t")
                        }
                    }

                    // MAKE OBJECT ITEMS
                    let items = []
                    for (let i = 1; i < rows.length; i++) {
                        if (rows[i]) {
                            let item = {}
                            for (let j = 0; j < rows[0].length; j++) {
                                item[rows[0][j].trim()] = rows[i][j]
                            }
                            items.push(item)
                        }
                    }

                    rows = []
                    for (let k = 0; k < items.length; k++) {
                        let row = items[k]

                        let traveller = {}
                        for (const [key, value] of Object.entries(row)) {


                            if (value) {
                                let data = value.trim().toUpperCase()
                                let colname = key.toLowerCase()
                                if (colname == 'passenger') {
                                    traveller.passenger = data
                                }
                                if (colname == 'surname') {
                                    traveller.surname = data
                                }
                                if (colname == 'firstname') {
                                    traveller.firstname = data
                                }
                                if (colname == 'title') {
                                    traveller.title = data
                                }
                                if (colname.includes('dob')) {
                                    // NEED TO CHECK WHERE THE YEAR IS
                                    traveller.dob = data
                                }
                                if (colname.includes('mob')) {
                                    traveller.mob = data
                                }
                                if (!traveller.surname && colname.includes('name')) {
                                    let names = data.split(' ')
                                    names = names.filter(item => item);
                                    names = names.reverse()
                                    traveller.surname = names[0]
                                    names.shift()
                                    traveller.firstname = names.join(" ")
                                }
                            }
                        }
                        if (!traveller.passenger) {
                            if (traveller.surname) {
                                traveller.passenger = traveller.surname
                                if (traveller.firstname) {
                                    traveller.passenger += "/" + traveller.firstname.split(' ')[0]
                                }
                            }
                        }
                        if (traveller.passenger) {
                            let found = rows.find(o => o.passenger == traveller.passenger)
                            if (!found) {
                                traveller.paxtype = "ADT"
                                traveller.travellernumber = (rows.length + 1).toString()
                                traveller.sabrenamenumber = (rows.length + 1).toString() + ".1"
                                rows.push(traveller)
                            }
                        }
                    }

                    // OK WE HAVE ROWS
                    if (state.paste_selected.includes("replace")) {
                        state.items = rows
                    } else {
                        if (!state.items) { state.items = [] }
                        let offset = state.items.length + 1
                        for (let i = 0; i < rows.length; i++) {
                            let found = state.items.find(o => o.passenger == rows[i].passenger)
                            if (!found) {
                                state.items.push({
                                    ...rows[i],
                                    travellernumber: (offset).toString(),
                                    sabrenamenumber: (offset).toString() + ".1"
                                })
                                offset += 1
                            } else {
                                found.title = rows[i].title ? rows[i].title : ""
                                found.firstname = rows[i].firstname ? rows[i].firstname : ""
                                found.dob = rows[i].dob ? rows[i].dob : ""
                                found.mob = rows[i].mob ? rows[i].mob : ""
                            }
                        }

                    }
                } catch (error) {
                    console.log(error)
                }


            }
        },
        // async travellers_formatter() {

        //     let state = this.travellers;
        //     state.paste = state.paste.split("\"").join("").split("&").join("\n").split(",").join("\n").split(" \n").join("\n").split("\n").join("#")
        //     state.paste = state.paste.replace(/[#_,]+/g, '\n')
        // },

        async travellers_saveit() {
            console.log('travellers_saveit')

            this.message = ""

            this.travellers.busy = true;

            let variables = {
                rows: [{
                    id: this.item.id,
                    // bltotal: this.item.bltotal,
                    // blinvoiceno: this.item.blinvoiceno,
                    // proforma: this.travellers.items,
                }]
            }

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
                        mutation bookings_save($rows: [Booking_input]) {
                            bookings_save(rows: $rows) {
                                id
                                travellers {
                                    id
                                }
                            }
                        }
                        `,
                    variables,
                });
                this.message = "<span class='text-primary'>Saved it.</span>";

            } catch (error) {
                this.message = "<span class='text-danger'>" + error.message + "</span>";
            }
            this.travellers.busy = false;

        },

        async segments_load(offset, limit, page) {
        },

        async segments_click(a, ss) {
            console.log("segments_click", a, ss);

            let state = this.segments;
            let found = null
            let route = null
            switch (a) {
                case "go":
                    await this.load();
                    break;

                case "add":
                    state.items.push({ type: this.item.type, segmentno: "S" + String(state.items.length + 1).padStart(2, '0'), fare: "0.00", tax: "0.00" })
                    break;

                case "clone":
                    state.items.push({ ...state.item, type: this.item.type, segmentno: "S" + String(state.items.length + 1).padStart(2, '0') })
                    break;

                case "edit":
                    state.edit = !state.edit
                    break;

                case "reset":
                    this.travellers.items = []
                    this.segments.items = []
                    this.itineraries.items = []
                    break;

                case "pastespecial":
                    state.pastespecial = !state.pastespecial
                    break;


                case "delete":
                    for (let i = 0; i < ss.length; i++) {
                        found = state.items.findIndex(o => o.segmentno == ss[i].segmentno)
                        if (found != -1) {
                            state.items.splice(found, 1)
                        }
                    }
                    break;

                case "up":
                    for (let i = 0; i < ss.length; i++) {
                        found = state.items.findIndex(o => o.locator == ss[i].locator)
                        console.log(found)
                        if (found != -1) {
                            let target = found - 1
                            if (target != -1) {
                                console.log('move up', found, target, state.items.length)
                                this.moveItem(state.items, found, target)
                            }

                        }
                    }
                    break;

                case "down":
                    for (let i = 0; i < ss.length; i++) {
                        found = state.items.findIndex(o => o.locator == ss[i].locator)
                        console.log(found)
                        if (found != -1) {
                            let target = found + 1
                            if (target != -1) {
                                this.moveItem(state.items, found, target)
                            }

                        }
                    }
                    break;

                case "top":
                    for (let i = 0; i < ss.length; i++) {
                        found = state.items.findIndex(o => o.locator == ss[i].locator)
                        if (found != -1) {
                            let target = 0
                            if (target != -1) {
                                console.log('move up', found, target, state.items.length)
                                this.moveItem(state.items, found, target)
                            }

                        }
                    }
                    break;

                case "save":
                    await this.segments_saveit()
                    break;

            }
        },

        async segments_select(ss, tools) {
            // return
            console.log("segments_select", ss);

            let state = this.segments;

            state.selected = ss;
            let tool = null;

            if (tools) {
                let enabled = ["back", "go", "filter", "reset", "add", "clipboard", "export", "pastespecial"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = false;
                    }
                });
                // == 1
                enabled = ["edit", "clone", "up", "down", "top"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length == 1 ? false : true;
                    }
                });
                // > 1
                enabled = ["save", "deleteconfirm"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length > 0 ? false : true;
                    }
                });

                if (!state.denied) {
                    state.denied = [];
                }
                state.denied.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.visible = false;
                    }
                });
            }

            if (state.selected.length > 0) {
                state.item = state.selected[0]  // WHAT YOU SELECTED

                if (state.item.start_at) {
                    let v = this.moment().utc(false).format("YYYY-MM-DD HH:mm")
                    if (state.item.start_at != 'NaN') {
                        v = this.$moment.unix(state.item.start_at / 1000).utc(false).format("YYYY-MM-DD HH:mm")
                    }
                    this.segments.datestart = { startDate: v, endDate: v }
                }
                if (state.item.end_at) {
                    let v = this.moment().utc(false).format("YYYY-MM-DD HH:mm")
                    if (state.item.end_at != 'NaN') {
                        v = this.$moment.unix(state.item.end_at / 1000).utc(false).format("YYYY-MM-DD HH:mm")
                    }
                    if (this.segments.datesameasstart) {
                        state.item.end_at = state.item.start_at
                    }
                    this.segments.dateend = { startDate: v, endDate: v }
                }

            } else {
                state.item = {}
            }

            this.message = ""
        },
        async segments_update(a, v) {
            console.log(a, v)

            let state = this.segments;

            switch (a) {
                case "datestart":
                    state.item.start_at = this.$moment(v.startDate).utc(true).valueOf().toString()
                    break;
                case "dateend":
                    state.item.end_at = this.$moment(v.startDate).utc(true).valueOf().toString()
                    break;
            }

        },
        async segments_tab() {
            let state = this.segments;
            let content = state.paste
            state.paste += "\t"

        },
        async segments_headers() {
            let state = this.segments;
            let content = state.paste
            state.paste = "SegmentNo\tStart City\tStart Location\tStart Datetime\tEnd City\tEnd Location\tEnd Datetime\tCabin\tDuration\tClass\tClassname\tEquipment\tSupplier\tFare\tTax\n"
            if (content) {
                state.paste += content
            }
        },
        async segments_paste_read() {

            let state = this.segments;

            if (state.paste) {

                let rows = tabToObjArr(state.paste)
                console.log('rows=', rows)

                let rowstart = 1
                if (state.paste_selected.includes("secondrowskip")) {
                    rowstart += 1
                }

                // MAKE OBJECT ITEMS
                let items = []
                for (let i = rowstart; i < rows.length; i++) {
                    items.push(rows[i])
                }
                console.log('items', items)

                if (state.paste_selected.includes("filldown")) {
                    let lastitem = {}
                    for (let i = 0; i < items.length; i++) {
                        let item = items[i]
                        for (let prop in lastitem) {
                            if (!item[prop]) {
                                if (lastitem[prop]) {
                                    item[prop] = lastitem[prop]
                                }
                            }
                        }
                        lastitem = item
                    }
                }
                console.log('fill downs', rows)

                let found = null

                rows = []
                for (let i = 0; i < items.length; i++) {
                    let obj = items[i]

                    let segment = {
                        type: this.item.type,
                        segmentno: "S" + (i + 1).toString(),
                        cabin: "ECONOMY",
                        status: "HK",
                        fare: "0.00",
                        tax: "0.00",
                        travellers: []
                    }
                    if (segment.type == "RAI") {
                        segment.equipment = "RAIL"
                        segment.classcode = "S"
                        segment.classname = "STANDARD"
                    }
                    if (segment.type == "XFR") {
                        segment.classcode = "S"
                    }

                    let start_at = ""
                    let end_at = ""
                    let datetravel = ""
                    let parts = []
                    for (let prop in obj) {

                        try {
                            if (obj[prop]) {
                                let data = obj[prop].trim().toUpperCase()
                                let colname = prop.toLowerCase()

                                if (colname == 'segmentno') {
                                    segment.segmentno = data
                                }
                                if (colname == 'segmentname') {
                                    segment.segmentname = data
                                }
                                if (colname == 'segmentgroup') {
                                    segment.segmentgroup = data
                                }
                                if (colname == 'traveller' || colname == 'mob' || colname == 'name' || colname == 'names') {
                                    parts = data.split(",")
                                    for (let k = 0; k < parts.length; k++) {
                                        let nameinput = parts[k].trim()
                                        if (nameinput) {
                                            if (nameinput.length > 2) {
                                                let names = nameinput.split(' ')
                                                names = names.filter(item => item);
                                                names = names.reverse()
                                                let traveller = { paxtype: "ADT" }
                                                traveller.surname = names[0]
                                                names.shift()
                                                traveller.firstname = names.join(" ")
                                                traveller.passenger = traveller.surname + "/" + traveller.firstname
                                                if (k + 1 < parts.length) {
                                                    if (parts[k + 1].trim().slice(0, 1) == "+") {
                                                        traveller.mob = parts[k + 1].trim()
                                                        parts[k + 1] = ""
                                                    }
                                                }
                                                found = segment.travellers.find(o => o.passenger == traveller.passenger)
                                                if (!found) {
                                                    segment.travellers.push(traveller)
                                                }

                                                found = this.travellers.items.find(o => o.passenger == traveller.passenger)
                                                if (!found) {
                                                    this.travellers.items.push(traveller)
                                                }
                                            }
                                        }
                                    }
                                }

                                if (colname == 'start city') {
                                    segment.startcity = data
                                }
                                if (colname == 'start location' || colname == 'departure station' || colname == 'pick up' || colname == 'pickup') {
                                    segment.startlocation = data
                                }
                                if (colname == 'start datetime' || colname == 'date') {
                                    if (this.$moment(data, 'DD/MM/YYYY').isValid()) {
                                        console.log('is valid', 'DD/MM/YYYY')
                                        segment.start_at = this.$moment(data, 'DD/MM/YYYY HH:mm').format('YYYY-MM-DD HH:mm')
                                        start_at = this.$moment(data, 'DD/MM/YYYY HH:mm').format('HH:mm')
                                    } else if (this.$moment(data, 'dddd Do MMMM YYYY').isValid()) {
                                        console.log('is valid', 'dddd Do MMMM YYYY')
                                        segment.start_at = this.$moment(data, 'dddd Do MMMM YYYY').format('YYYY-MM-DD HH:mm')
                                    }
                                    if (segment.start_at) {
                                        datetravel = this.$moment(segment.start_at).format('YYYY-MM-DD')
                                    }
                                }
                                if (colname == 'end city') {
                                    segment.endcity = data
                                }
                                if (colname == 'end location' || colname == 'arrival station' || colname == 'drop off' || colname == 'dropoff') {
                                    segment.endlocation = data
                                }
                                if (colname == 'end datetime') {
                                    // if (this.$moment(data, 'DD/MM/YYYY').isValid()) {
                                    //     segment.start_at = this.$moment(data, 'DD/MM/YYYY HH:mm').format('YYYY-MM-DD HH:mm')
                                    //     start_at = this.$moment(data, 'DD/MM/YYYY HH:mm').format('HH:mm')
                                    // } else if (this.$moment(data, 'dddd Do MMMM YYYY').isValid()) {
                                    //     segment.start_at = this.$moment(data, 'dddd Do MMMM YYYY').format('YYYY-MM-DD HH:mm')
                                    // }

                                    segment.end_at = this.$moment(data, 'DD/MM/YYYY').mat('YYYY-MM-DD HH:mm')
                                    end_at = this.$moment(data, 'DD/MM/YYYY HH:mm').format('HH:mm')
                                    // segment.end_at = (this.$moment(segment.end_at).ufortc(true).unix() * 1000).toString()
                                }

                                // if (colname == 'date') {
                                //     let value = ""
                                //     if (data.includes(' ')) {
                                //         parts = data.split(' ')
                                //         value = parts[1]
                                //     } else {
                                //         value = data
                                //     }
                                //     datetravel = this.$moment(data, 'DD/MM/YYYY').format('YYYY-MM-DD')
                                // }
                                if (colname == 'departure' || colname == 'departure time') {
                                    data = data.split(' ').join('').split(':').join('')
                                    if (data.length < 4) {
                                        data = "0" + data
                                    }
                                    start_at = data.slice(0, 2)
                                    start_at += ":"
                                    start_at += data.slice(-2)
                                }
                                if (colname == 'arrival' || colname == 'arrival time') {
                                    data = data.split(' ').join('').split(':').join('')
                                    if (data.length < 4) {
                                        data += "0"
                                    }
                                    end_at = data.slice(0, 2)
                                    end_at += ":"
                                    end_at += data.slice(-2)
                                }
                                if (colname == 'equipment' || colname == 'aircraft') {
                                    segment.equipment = data
                                }
                                if (colname == 'airline' || colname == 'supplier') {
                                    segment.vendorcode = data
                                }
                                if (colname == 'duration' || colname == 'journey time') {
                                    // parts = data.split(' ')
                                    segment.duration = data
                                }
                                if (colname == 'classname' || colname == 'ticket type') {
                                    segment.classname = data
                                    if (data.toLowerCase().includes('business')) {
                                        segment.cabin = "BUSINESS"
                                    }
                                    if (data.toLowerCase().includes('1st')) {
                                        segment.cabin = "FIRST"
                                    }
                                }
                                if (colname == 'seats') {
                                    segment.seats = data.toUpperCase().split("SEATER").join("").trim()
                                    if (segment.seats.includes('-')) {
                                        let parts = segment.seats.split('-')
                                        segment.seats = parts[1].trim()
                                    }
                                    // if (!parseInt(segment.seats)) {
                                    //     segment.seats = segment.seats.slice(-1)
                                    // }
                                }
                                if (colname == 'notes') {
                                    segment.notes = data
                                }
                                if (colname == 'fare') {
                                    segment.fare = parseFloat(data.split(',').join('')).toFixed(2)
                                }
                                if (colname == 'tax') {
                                    segment.tax = parseFloat(data.split(',').join('')).toFixed(2)
                                }
                            }

                        } catch (error) {
                            console.log('error here', error)
                        }

                    }
                    if (datetravel) {
                        // if (!segment.end_at) {
                        //     segment.end_at = segment.start_at
                        // }
                        // if (!segment.start_at.includes(':') && start_at) {
                        //     segment.start_at += " " + start_at
                        // }
                        // if (!segment.end_at.includes(':') && end_at) {
                        //     segment.end_at += " " + end_at
                        // }
                        if (datetravel) {
                            if (!end_at) { end_at = start_at }
                            segment.start_at = (this.$moment(datetravel + " " + start_at).utc(true).unix() * 1000).toString()
                            segment.end_at = (this.$moment(datetravel + " " + end_at).utc(true).unix() * 1000).toString()
                        }
                    }
                    if (segment.startcity && segment.endcity) {
                        segment.route = segment.startcity + "/" + segment.endcity
                    }
                    if (!segment.route && segment.startlocation && segment.endlocation) {
                        parts = segment.startlocation.split(' ')
                        segment.route = parts[0]
                        segment.route += "/"
                        parts = segment.endlocation.split(' ')
                        segment.route += parts[0]
                    }
                    if (!segment.equipment && segment.seats && segment.type == "XFR") {
                        if (parseFloat(segment.seats) > 20) {
                            segment.equipment = "COACH"
                        }
                        if (parseFloat(segment.seats) > 7 && parseFloat(segment.seats) <= 20) {
                            segment.equipment = "MINIBUS"
                        }
                        if (parseFloat(segment.seats) > 0 && parseFloat(segment.seats) < 7) {
                            segment.equipment = "TAXI"
                        }
                        if (parseFloat(segment.seats) == 0) {
                            segment.equipment = "MINIVAN"
                        }
                    }
                    if (this.segmentgroup) {
                        segment.segmentgroup = this.segmentgroup.trim().toUpperCase()
                    }

                    rows.push(segment)
                }

                let i = 0
                for (i = 0; i < rows.length; i++) {
                    let segment = rows[i]
                    found = this.segments.items.filter(o => o.segmentno == segment.segementno && o.start_at == segment.start_at && o.startlocation == segment.startlocation && o.segmentname == segment.segmentname)
                    if (found.length == 0) {
                        segment.segmentno = "S" + (state.items.length + 1).toString()
                        state.items.push(segment)
                    } else {
                        //UPDATE IT?
                        console.log(found[0].segmentno)
                    }
                }

                for (i = 0; i < rows.length; i++) {
                    let segment = rows[i]
                    let k = 0
                    if (segment.travellers) {
                        for (k = 0; k < segment.travellers.length; k++) {
                            let traveller = segment.travellers[k]
                            console.log('looking for', traveller.passenger)
                            found = this.itineraries.items.find(o => o.passenger == traveller.passenger)
                            if (!found) {
                                this.itineraries.items.push({
                                    passenger: traveller.passenger,
                                    start_at: segment.start_at,
                                    segmentno: segment.segmentno,
                                    fare: "0.00",
                                    tax: "0.00",
                                })
                            } else {
                                console.log('found', found, segment.segmentno)
                                if (!found.segmentno.includes(segment.segmentno)) {
                                    found.segmentno = found.segmentno + "," + segment.segmentno
                                }
                            }
                        }
                    }
                    delete segment.travellers
                }

                // // OK WE HAVE ROWS
                // if (state.paste_selected.includes("replace")) {
                //     state.items = rows
                // } else {
                //     if (!state.items) { state.items = [] }

                //     let offset = state.items.length + 1
                //     for (let i = 0; i < rows.length; i++) {
                //         // let found = state.items.find(o => o.locator == rows[i].locator)
                //         // console.log('found', found,travellers[i].passenger)
                //         // if (!found) {
                //         state.items.push({
                //             ...rows[i],
                //             segmentno: "S" + (offset + i).toString(),
                //         })
                //         //     offset += 1
                //         // } else {
                //         //     found.startlocation = rows[i].startlocation ? rows[i].startlocation : ""
                //         //     found.endlocation = rows[i].endlocation ? rows[i].endlocation : ""
                //         // }
                //     }


                // }
            }
        },

        async segments_saveit() {
            console.log('segments_saveit')

            this.message = ""

            this.segments.busy = true;

            let variables = {
                rows: [{
                    id: this.item.id,
                    // bltotal: this.item.bltotal,
                    // blinvoiceno: this.item.blinvoiceno,
                    // proforma: this.segments.items,
                }]
            }

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
                        mutation bookings_save($rows: [Booking_input]) {
                            bookings_save(rows: $rows) {
                                id
                                segments {
                                    id
                                }
                            }
                        }
                        `,
                    variables,
                });
                this.message = "<span class='text-primary'>Saved it.</span>";

            } catch (error) {
                this.message = "<span class='text-danger'>" + error.message + "</span>";
            }
            this.segments.busy = false;

        },

        async itineraries_load(bytype) {

            let state = this.itineraries;
            state.busy = true



            state.busy = false

        },

        async itineraries_click(a, ss) {
            console.log("itineraries_click", a, ss);

            let state = this.itineraries;
            let found = null
            let route = null
            switch (a) {
                case "go":
                    await this.load();
                    break;

                case "edit":
                    state.edit = !state.edit
                    break;

                case "reset":
                    this.travellers.items = []
                    this.segments.items = []
                    this.itineraries.items = []
                    break;

                case "pastespecial":
                    state.pastespecial = !state.pastespecial
                    break;

                case "delete":
                    for (let i = 0; i < ss.length; i++) {
                        found = state.items.findIndex(o => o.passenger == ss[i].passenger)
                        if (found != -1) {
                            state.items.splice(found, 1)
                        }
                    }
                    break;

                case "up":
                    for (let i = 0; i < ss.length; i++) {
                        found = state.items.findIndex(o => o.passenger == ss[i].passenger)
                        console.log(found)
                        if (found != -1) {
                            let target = found - 1
                            if (target != -1) {
                                console.log('move up', found, target, state.items.length)
                                this.moveItem(state.items, found, target)
                            }

                        }
                    }
                    break;

                case "down":
                    for (let i = 0; i < ss.length; i++) {
                        found = state.items.findIndex(o => o.passenger == ss[i].passenger)
                        console.log(found)
                        if (found != -1) {
                            let target = found + 1
                            if (target != -1) {
                                this.moveItem(state.items, found, target)
                            }

                        }
                    }
                    break;

                case "top":
                    for (let i = 0; i < ss.length; i++) {
                        found = state.items.findIndex(o => o.passenger == ss[i].passenger)
                        if (found != -1) {
                            let target = 0
                            if (target != -1) {
                                console.log('move up', found, target, state.items.length)
                                this.moveItem(state.items, found, target)
                            }

                        }
                    }
                    break;

                case "markup_costtotal":
                    let markup_total = parseFloat(this.markup_costtotal)
                    let markup_line = (markup_total / this.itineraries.items.length).toFixed(2)
                    let markup_remainder = (markup_total - (markup_line * this.itineraries.items.length)).toFixed(2)

                    console.log('set the markup total to', this.markup_costtotal, markup_total, markup_line, markup_remainder)
                    for (var j = 0; j < this.itineraries.items.length; j++) {
                        if (j < this.itineraries.items.length - 1) {
                            this.itineraries.items[j].fare = (parseFloat(markup_line) - parseFloat(this.itineraries.items[j].tax)).toFixed(2)
                        } else {
                            this.itineraries.items[j].fare = ((parseFloat(markup_line) - parseFloat(this.itineraries.items[j].tax)) + parseFloat(markup_remainder)).toFixed(2)
                        }
                    }
                    this.sumcosttotal()
                    break;

                case "bytravellers":
                case "bysegments":
                    await this.itineraries_change(a)
                    break;


                case "save":
                    await this.itineraries_saveit()
                    break;

            }
        },

        async itineraries_select(ss, tools) {
            // return
            console.log("itineraries_select", ss);

            let state = this.itineraries;

            state.selected = ss;
            let tool = null;

            if (tools) {
                let enabled = ["back", "go", "filter", "reset", "add", "clipboard", "export", "pastespecial", "itinerarybytravellers", "itinerarybysegments"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = false;
                    }
                });
                // == 1
                enabled = ["edit", "clone", "up", "down", "top"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length == 1 ? false : true;
                    }
                });
                // > 1
                enabled = ["save", "deleteconfirm"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length > 0 ? false : true;
                    }
                });

                if (!state.denied) {
                    state.denied = [];
                }
                state.denied.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.visible = false;
                    }
                });
            }

            if (state.selected.length > 0) {
                state.item = state.selected[0]  // WHAT YOU SELECTED
                this.itinerary_segments = state.item.segmentno.split(",")

                // this.datetravel = this.$moment.unix(state.item.datetravel * 0.001).utc(true).format("YYYY-MM-DD")

            } else {
                state.item = {}
            }

            this.message = ""
        },

        async itineraries_tab() {
            let state = this.itineraries;
            let content = state.paste
            state.paste += "\t"

        },
        async itineraries_headers() {
            let state = this.itineraries;
            let content = state.paste
            state.paste = "TravellerNo\tSegmentNo\tFare\tTax\tConfirmNo\n"
            if (content) {
                state.paste += content
            }
        },
        async itineraries_paste_read() {

            let state = this.itineraries;

            if (state.paste) {

                // STAGE ONE, SPLIT BY LINE
                let rows = state.paste.split("\n")
                for (let i = 0; i < rows.length; i++) {
                    // SPLIT BY COL
                    if (rows[i]) {
                        rows[i] = rows[i].split("\t")
                    }
                }

                // MAKE OBJECT ITEMS
                let items = []
                for (let i = 1; i < rows.length; i++) {
                    if (rows[i]) {
                        let item = {}
                        for (let j = 0; j < rows[0].length; j++) {
                            item[rows[0][j].trim()] = rows[i][j]
                        }
                        items.push(item)
                    }
                }

                rows = []
                for (let i = 0; i < items.length; i++) {
                    let obj = items[i]
                    let itinerary = {}
                    switch (this.item.type) {
                        case "RAI":
                            itinerary.associatedno = "RAIL"
                            break;
                        case "XFR":
                            itinerary.associatedno = "TRANSFER"
                            break;
                    }

                    for (let prop in obj) {
                        // if (obj[prop]) {
                        let data = obj[prop].toUpperCase()
                        let colname = prop.toLowerCase()
                        if (colname == 'passenger') {
                            itinerary.passenger = data
                        }
                        if (colname == 'travellerno' || colname == 'passengerno') {
                            let index = data.split('P').join('').split('T').join('')
                            let traveller = this.travellers.items[parseInt(index - 1)]
                            if (traveller) {
                                itinerary.passenger = traveller.passenger
                            }
                        }
                        if (colname == 'segmentno') {
                            itinerary.segmentno = data

                            let fare = 0
                            let tax = 0
                            let list = data.split(",")
                            let routing = []
                            for (let k = 0; k < list.length; k++) {
                                let segmentno = list[k]
                                let segment = this.segments.items.find(o => o.segmentno == segmentno)
                                if (segment) {
                                    if (segment.fare) {
                                        fare += parseFloat(segment.fare)
                                    }
                                    if (segment.tax) {
                                        tax += parseFloat(segment.tax)
                                    }
                                    // GET THE DATE OF TRAVEL FROM FIRST SEGMENT
                                    if (k == 0) {
                                        itinerary.start_at = segment.start_at
                                    }
                                    if (segment.route) {
                                        let parts = segment.route.split("/")
                                        routing.push(parts[0])

                                        // RETURN HOME
                                        if (k == list.length - 1) { routing.push(parts[1]) }

                                    }

                                }
                                itinerary.route = routing.join("/")
                            }
                            itinerary.fare = fare.toFixed(2)
                            itinerary.tax = tax.toFixed(2)
                            itinerary.total = (fare + tax).toFixed(2)
                        }
                        if (colname == 'confirmno') {
                            itinerary.confirmno = data
                        }
                        if (colname == 'associatedno') {
                            itinerary.associatedno = data
                        }
                        if (colname == 'cabin') {
                            itinerary.cabin = data
                        }
                        if (colname == 'classcode') {
                            itinerary.classcode = data
                        }
                        if (colname == 'classname') {
                            itinerary.classname = data
                        }
                        if (colname == 'fare') {
                            itinerary.fare = parseFloat(data.split(',').join('')).toFixed(2)
                        }
                        if (colname == 'tax') {
                            itinerary.tax = parseFloat(data.split(',').join('')).toFixed(2)
                        }
                        // }
                    }

                    if (!itinerary.fare) { itinerary.fare = "0.00" }
                    if (!itinerary.tax) { itinerary.tax = "0.00" }
                    itinerary.total = (parseFloat(itinerary.fare) + parseFloat(itinerary.tax)).toFixed(2)

                    rows.push(itinerary)
                }
                console.log(rows)

                // OK WE HAVE ROWS
                if (state.paste_selected.includes("replace")) {
                    console.log('replacing')
                    state.items = rows
                } else {
                    console.log('appending')
                    if (!state.items) { state.items = [] }

                    let offset = state.items.length + 1
                    for (let i = 0; i < rows.length; i++) {
                        let found = state.items.find(o => o.passenger == rows[i].passenger)
                        if (!found) {
                            state.items.push({
                                ...rows[i],
                            })
                            offset += 1
                        } else {
                            // found.title = rows[i].title ? rows[i].title : ""
                            // found.firstname = rows[i].firstname ? rows[i].firstname : ""
                            // found.dob = rows[i].dob ? rows[i].dob : ""
                        }
                    }

                }

            }
        },

        async itineraries_change(proforma_layout) {
            console.log('itineraries_change', proforma_layout)
            this.message = ""

            this.itineraries.busy = true;

            let variables = {
                rows: [{ id: this.item.id }],
                proforma_layout
            }

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
                        mutation bookings_changelayout($rows: [Booking_input], $proforma_layout: String) {
                            bookings_changelayout(rows: $rows, proforma_layout: $proforma_layout) {
                                start_at
                                associatedno
                                passenger
                                route
                                segmentno
                                confirmno
                                fare
                                tax
                                total
                            }
                        }
                        `,
                    variables,
                });
                this.message = "<span class='text-primary'>Saved it.</span>";
                this.itineraries.items = response.data.bookings_changelayout
                this.item.proforma_layout = proforma_layout

            } catch (error) {
                this.message = "<span class='text-danger'>" + error.message + "</span>";
            }
            this.itineraries.busy = false;

            // await this.load();
        },

        async itineraries_saveit() {
            console.log('itineraries_saveit')

            this.message = ""

            this.itineraries.busy = true;

            let variables = {
                rows: [{
                    id: this.item.id,
                    // bltotal: this.item.bltotal,
                    // blinvoiceno: this.item.blinvoiceno,
                    // proforma: this.itineraries.items,
                }]
            }

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
                        mutation bookings_save($rows: [Booking_input]) {
                            bookings_save(rows: $rows) {
                                id
                                itineraries {
                                    id
                                }
                            }
                        }
                        `,
                    variables,
                });
                this.message = "<span class='text-primary'>Saved it.</span>";

            } catch (error) {
                this.message = "<span class='text-danger'>" + error.message + "</span>";
            }
            this.itineraries.busy = false;

        },
        sumcosttotal() {
            // this.costtotal = 0
            this.costtotal = 0
            if (this.itineraries.items) {
                for (var j = 0; j < this.itineraries.items.length; j++) {
                    if (isNaN(this.itineraries.items[j].fare)) { this.itineraries.items[j].fare = "0" }
                    this.itineraries.items[j].fare = parseFloat(this.itineraries.items[j].fare).toFixed(2)
                    this.itineraries.items[j].total = (parseFloat(this.itineraries.items[j].fare) + parseFloat(this.itineraries.items[j].tax)).toFixed(2);

                    // this.costtotal += parseFloat(this.sllines.items[j].bltotal)
                    this.costtotal += parseFloat(this.itineraries.items[j].total)
                }
            }
            this.markup_costtotal = this.costtotal.toFixed(2)
        },
        moveItem(data, from, to) {
            // remove `from` item and store it
            var f = data.splice(from, 1)[0];
            // insert stored item into position `to`
            data.splice(to, 0, f);
        },
        reversenamecap(data, ispassenger) {
            if (data) {
                let result = data.toString().toUpperCase()
                if (result) {
                    let parts = result.split(' ')
                    result = parts[parts.length - 1] + "/"
                    if (ispassenger) { this.item.surname = parts[parts.length - 1] }
                    parts = parts.slice(0, -1)
                    if (parts.length > 0) {
                        result += parts.join(" ")
                        if (ispassenger) { this.item.firstname = parts.join(" ") }
                    }
                    this.item.title = ""
                }
                return result
            }
        },

        async download() {
            let variables = {
                name: "sheet_bookings",
            };
            console.log("variables", variables);

            this.busy = true;

            try {
                const response = await this.$apollo.query({
                    query: gql`
            query setup_systemsettings($name: String) {
              setup_systemsettings(name: $name) {
                data
              }
            }
          `,
                    variables,
                });

                if (response.data.setup_systemsettings.length > 0) {
                    let sheet = response.data.setup_systemsettings[0].data;

                    let byteCharacters = atob(sheet);
                    let byteNumbers = new Array(byteCharacters.length);
                    for (let i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    let byteArray = new Uint8Array(byteNumbers);
                    let blob = new Blob([byteArray], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                    fs.saveAs(blob, 'TEMPLATE_bookings' + ".xlsx");
                }
            } catch (error) {
                console.log(error);
            }
            this.busy = false;
        },


    },
};
</script>

<style>
.ssh-pre__content {
    color: #3cb450;
}

.ssh-pre .quote {
    color: #0bc;
}

.ssh-pre[data-type="xml"] .tag-name {
    color: #c6d;
}
</style>